import { AnnualMaskReceiptDateText } from "../../Followup/AnnualMaskReceiptDate";
import React, {
  Fragment,
  useEffect,
  useMemo,
  useState,
  useRef,
} from "react";
import * as XLSX from "xlsx";
import { db, functions } from "../../../../firebase";
import { connect } from "react-redux";

import {
  Button,
  Modal,
  Table,
  Badge,
  Card,
  Form,
  Dropdown,
} from "react-bootstrap";
import fontkit from "@pdf-lib/fontkit";
import { PDFDocument } from "pdf-lib";
import { createMultipleStockLogs } from "../../../../utils/stockLogs";
import {
  cancelSaleOrderWithLots,
  formatOrderItemAllocations,
  isAccessoryOrderItem,
  isExcelImportedSaleOrder,
  updateSaleOrderWithLots,
} from "../../../../utils/accessoryLotInventory";
import { getPatientPagePath } from "../../../../utils/patientPageUtils";
import { Link } from "react-router-dom";
import {
  doc,
  onSnapshot,
  getDocs,
  getDoc,
  orderBy,
  limit,
  where,
  query,
  collection,
  and,
  or,
  setDoc,
  updateDoc,
  deleteDoc,
  writeBatch,
} from "firebase/firestore";

import swal from "sweetalert";
import PageTitle from "../../../layouts/PageTitle";
import { usePagination } from "../../../../hook/usePagination";
import { useAuth } from "../../../../context/AuthContext";
import { httpsCallable } from "firebase/functions";
import {
  startSetFiles,
  setFiles,
  startAddFile,
} from "../../../../actions/productFiles";
import selectFiles from "../../../../selectors/productFiles";
import { getSalePackageAccessories } from "./salePackageAccessories";
import {
  normalizeCpapDeviceNo,
  resolveCpapDeviceNo,
} from "./cpapDeviceNumber";
import {
  formatAccessoryReceiptLots,
  formatCpapReceiptIdentification,
  formatCpapReceiptMaskLine,
  formatCpapReceiptMaskLots,
  getStandaloneAccessoryReceiptItems,
  resolveCpapLotNo,
  splitSaleOrderReceiptItems,
} from "./saleOrderReceipt";
import {
  calculateWarrantyEndDate,
  DEFAULT_WARRANTY_PERIOD,
  formatWarrantyDate,
  isSupportedWarrantyPeriod,
  WARRANTY_PERIOD_OPTIONS,
} from "../warrantyUtils";
import { filterSaleOrders } from "./saleOrderSearch";
import {
  uploadSaleOrderESlip,
  deleteSaleOrderAttachment,
  matchesSaleOrderAttachment,
} from "./saleOrderESlip";
import {
  ANNUAL_MASK_STATUS,
  getAnnualMaskCaseStatusForSaleOrder,
} from "../../Followup/annualMaskPurchaseUtils";

const CPAP_RECEIPT_TEMPLATE_URL =
  "https://firebasestorage.googleapis.com/v0/b/sleepy-9b23f.firebasestorage.app/o/templates%2FF-930-002-A%20CPAP_Receipt_and_Warranty_Form.pdf?alt=media&token=9a301059-2da2-4917-b68d-8928a1d1af33";
const MASK_ACCESSORY_RECEIPT_TEMPLATE_URL =
  "https://firebasestorage.googleapis.com/v0/b/sleepy-9b23f.firebasestorage.app/o/templates%2FF-930-003%20CPAP_Mask_and_Accessories_Receipt_Form.pdf?alt=media&token=a32c541b-6bb0-48e7-9a75-a0ff8a199b02";
const CPAP_RECEIPT_FONT_URL = "./assets/fonts/Sarabun-Light.ttf";
const MAX_ACCESSORY_LINES = 8;
const ACCESSORY_QUANTITY_X = 430;
const MASK_ACCESSORY_ITEMS_PER_PAGE = 4;
const MASK_ACCESSORY_QUANTITY_X = 470;

const loadReceiptTemplate = async (templateUrl, errorMessage) => {
  const response = await fetch(templateUrl);
  if (!response.ok) {
    throw new Error(errorMessage);
  }

  const templatePdf = await PDFDocument.load(await response.arrayBuffer());
  if (templatePdf.getPageCount() === 0) {
    throw new Error("The receipt template does not contain a page.");
  }

  return templatePdf;
};

const getSaleValuesForQuery = (sale, salesSelect = []) => {
  if (!sale || sale === "ทั้งหมด" || sale === "All") return [];

  const cleanSale = sale.trim();

  // "B.Sunisa" -> "Sunisa"
  const nameOnly = cleanSale.includes(".")
    ? cleanSale.split(".").slice(1).join(".")
    : cleanSale;

  // Find full sale from salesSelect
  // Example: "Sunisa" -> "B.Sunisa"
  const fullSale = salesSelect.find((item) => {
    const cleanItem = String(item).trim();
    const itemNameOnly = cleanItem.includes(".")
      ? cleanItem.split(".").slice(1).join(".")
      : cleanItem;

    return cleanItem === cleanSale || itemNameOnly === nameOnly;
  });

  const values = [];

  if (cleanSale) values.push(cleanSale);

  if (nameOnly && !values.includes(nameOnly)) {
    values.push(nameOnly);
  }

  if (fullSale && !values.includes(fullSale)) {
    values.push(fullSale);
  }

  return values;
};

const getPdfText = (value) =>
  value === null || value === undefined ? "" : String(value);

const resolveCpapItemPdfDetails = async (cpapItem) => {
  const savedDeviceNo = normalizeCpapDeviceNo(cpapItem.deviceNo);
  const savedLotNo = resolveCpapLotNo(cpapItem.lotNo, "");

  const productId = getPdfText(cpapItem.productId).trim();
  if (!productId || (savedDeviceNo && savedLotNo)) {
    return {
      ...cpapItem,
      deviceNo: savedDeviceNo,
      lotNo: savedLotNo,
    };
  }

  try {
    const productInfo = await getDoc(doc(db, "products", productId));
    const productData = productInfo.exists() ? productInfo.data() : {};

    return {
      ...cpapItem,
      deviceNo: resolveCpapDeviceNo(cpapItem.deviceNo, productData.deviceNo),
      lotNo: resolveCpapLotNo(cpapItem.lotNo, productData.lotNo),
    };
  } catch (error) {
    console.warn(
      `Failed to load receipt details for CPAP product ${productId}:`,
      error,
    );
    return {
      ...cpapItem,
      deviceNo: savedDeviceNo,
      lotNo: savedLotNo,
    };
  }
};

const getOrderPatientName = (order, patient) => {
  const orderName = [order.firstname, order.lastname]
    .filter(Boolean)
    .join(" ")
    .trim();

  if (orderName) return orderName;

  return [patient.firstnameTh, patient.lastnameTh]
    .filter(Boolean)
    .join(" ")
    .trim();
};

const getOrderPatientNameWithSleepStudyOrder = (order, patient) => {
  const patientName = getOrderPatientName(order, patient);
  const sleepStudyOrder = getPdfText(order.sleepStudyOrder).trim();

  if (!patientName || !sleepStudyOrder) return patientName;

  return `${patientName}      ${sleepStudyOrder}`;
};

const getOrderDate = (value) => {
  if (!value) return null;

  const date = value.toDate ? value.toDate() : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const formatThaiDate = (value) => {
  const date = getOrderDate(value);
  if (!date) return "";

  return date.toLocaleString("th-TH", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

const getFittedText = (value, font, maxWidth, preferredSize, minSize = 7) => {
  const text = getPdfText(value);
  if (!text) return { text: "", size: preferredSize };

  let size = preferredSize;
  while (size > minSize && font.widthOfTextAtSize(text, size) > maxWidth) {
    size -= 0.25;
  }

  if (font.widthOfTextAtSize(text, size) <= maxWidth) {
    return { text, size };
  }

  const suffix = "...";
  let truncatedText = text;
  while (
    truncatedText &&
    font.widthOfTextAtSize(`${truncatedText}${suffix}`, size) > maxWidth
  ) {
    truncatedText = truncatedText.slice(0, -1);
  }

  return {
    text: truncatedText ? `${truncatedText}${suffix}` : "",
    size,
  };
};

const drawFittedText = (page, value, font, options) => {
  const { x, y, maxWidth, size, minSize } = options;
  const fittedText = getFittedText(value, font, maxWidth, size, minSize);

  if (!fittedText.text) return;

  page.drawText(fittedText.text, {
    x,
    y,
    size: fittedText.size,
    font,
  });
};

const drawCpapReceiptPage = (
  page,
  font,
  order,
  patient,
  cpapItem,
  accessories,
) => {
  const { width, height } = page.getSize();
  const fieldX = 216;
  const contentRight = width - 72;
  const patientName = getOrderPatientName(order, patient);
  const patientNameWithSleepStudyOrder =
    getOrderPatientNameWithSleepStudyOrder(order, patient);
  const receiptDate = formatThaiDate(order.receiptDate);
  const warrantyEndDate = formatThaiDate(order.warrantyEndDate);
  const maskItem = (order.items || []).find(
    (item) => item.productType === "Mask",
  );
  const maskLotText = formatCpapReceiptMaskLots(
    maskItem && maskItem.lotAllocations,
  );
  const maskAccessory = accessories.find((accessory) =>
    accessory.name.includes("หน้ากาก"),
  );
  const maskNameWithSize = [
    maskItem && maskItem.productName,
    maskItem && maskItem.size ? `Size ${maskItem.size}` : "",
  ]
    .filter(Boolean)
    .join(" ");
  const maskAccessoryName =
    maskAccessory && maskItem
      ? formatCpapReceiptMaskLine(
          maskAccessory.name,
          maskNameWithSize,
          maskLotText,
        )
      : "";
  const maskQuantityText =
    maskAccessory && maskAccessory.quantity
      ? `จำนวน ${maskAccessory.quantity}`
      : "";
  const requestedQuantityX = maskAccessoryName
    ? fieldX + font.widthOfTextAtSize(maskAccessoryName, 8.5) + 10
    : ACCESSORY_QUANTITY_X;
  const maximumQuantityX = maskQuantityText
    ? contentRight - font.widthOfTextAtSize(maskQuantityText, 8.5) - 2
    : contentRight;
  const accessoryQuantityX = maskLotText
    ? Math.min(
        Math.max(ACCESSORY_QUANTITY_X, requestedQuantityX),
        Math.max(ACCESSORY_QUANTITY_X, maximumQuantityX),
      )
    : ACCESSORY_QUANTITY_X;
  const drawField = (value, x, y, maxWidth, size = 9, minSize = 7) => {
    drawFittedText(page, value, font, {
      x,
      y,
      maxWidth,
      size,
      minSize,
    });
  };

  //drawField(order.hn, fieldX, height - 141.92, contentRight - fieldX);

  drawField(
    `${order.hn}      ${order.receiptNo || ""}`,
    fieldX,
    height - 139.92,
    contentRight - fieldX,
  );



  drawField(
    patientNameWithSleepStudyOrder,
    fieldX,
    height - 154.13,
    contentRight - fieldX,
  );
  drawField(
    patient.mobile || order.mobile || "",
    fieldX,
    height - 168.35,
    contentRight - fieldX,
  );
  drawField(
    patient.address1 || order.address1 || "",
    fieldX,
    height - 180.75,
    contentRight - fieldX,
  );
  drawField(
    cpapItem.productBrand || "",
    fieldX,
    height - 226.75,
    contentRight - fieldX,
  );
  drawField(
    cpapItem.productName || "",
    fieldX,
    height - 241.75,
    contentRight - fieldX,
  );
  drawField(
    formatCpapReceiptIdentification(
      cpapItem.productSn,
      cpapItem.deviceNo,
      cpapItem.lotNo,
    ),
    fieldX,
    height - 255.75,
    contentRight - fieldX,
  );
  drawField(receiptDate, 155, height - 271.95, 55);
  drawField(warrantyEndDate, 315, height - 271.95, contentRight - 315);

  accessories.forEach((accessory, index) => {
    const accessoryY = height - 289 - index * 10.2;
    const hasMaskName = accessory.name.includes("หน้ากาก") && maskItem;
    const accessoryName = hasMaskName
      ? formatCpapReceiptMaskLine(
          accessory.name,
          maskNameWithSize,
          maskLotText,
        )
      : accessory.name;

    drawField(
      accessoryName,
      fieldX,
      accessoryY,
      accessoryQuantityX - fieldX - 10,
      8.5,
      6,
    );

    drawField(
      accessory.quantity ? `จำนวน ${accessory.quantity}` : "",
      accessoryQuantityX,
      accessoryY,
      contentRight - accessoryQuantityX,
      8.5,
      7,
    );
  });

  drawField(patientName, 85, height - 767.275, 132, 8.5, 7);
  //drawField(order.sales || "", 367, height - 767.275, 132, 8.5, 7);
  drawField(receiptDate, 100, height - 785.075, 110, 8.5, 7);
  drawField(receiptDate, 390, height - 785.075, 110, 8.5, 7);
};

const getMaskAccessoryDescription = (item) => {
  const productBrand = getPdfText(item.productBrand).trim();
  const productName = getPdfText(item.productName).trim();
  const productNameWithBrand =
    productBrand &&
    productName &&
    !productName.toLowerCase().includes(productBrand.toLowerCase())
      ? `${productBrand} ${productName}`
      : productName || productBrand;

  return [
    productNameWithBrand,
    item.size ? `Size ${item.size}` : "",
  ]
    .filter(Boolean)
    .join("  ");
};

const drawMaskAccessoryReceiptPage = (
  page,
  font,
  order,
  patient,
  items,
  itemOffset,
  pageNumber,
  totalPages,
) => {
  const { width, height } = page.getSize();
  const fieldX = 140;
  const contentRight = width - 58;
  const patientName = getOrderPatientName(order, patient);
  const patientNameWithSleepStudyOrder =
    getOrderPatientNameWithSleepStudyOrder(order, patient);
  const receiptDate = formatThaiDate(order.receiptDate);
  const drawField = (value, x, y, maxWidth, size = 9, minSize = 7) => {
    drawFittedText(page, value, font, {
      x,
      y,
      maxWidth,
      size,
      minSize,
    });
  };

  drawField(
    `${order.hn || ""}      ${order.receiptNo || ""}`,
    fieldX,
    height - 139.92,
    contentRight - fieldX,
  );
  drawField(
    patientNameWithSleepStudyOrder,
    fieldX,
    height - 154.13,
    contentRight - fieldX,
  );
  drawField(
    patient.mobile || order.mobile || "",
    fieldX,
    height - 168.35,
    contentRight - fieldX,
  );
  drawField(
    patient.address1 || order.address1 || "",
    fieldX,
    height - 182.75,
    contentRight - fieldX,
  );
  drawField(receiptDate, fieldX, height - 223.55, contentRight - fieldX);

  if (totalPages > 1) {
    drawField(
      `หน้า ${pageNumber}/${totalPages}`,
      485,
      height - 237.55,
      contentRight - 485,
      8,
      7,
    );
  }

  items.forEach((item, index) => {
    const itemY = height - 255.5 - index * 11;
    const itemNumber = itemOffset + index + 1;
    const quantity = getPdfText(item.quantity).trim() || "1";
    const lotText = formatAccessoryReceiptLots(item.lotAllocations);
    const itemX = 82;
    const lotGap = 6;
    const itemDescription =
      `${itemNumber}. ${getMaskAccessoryDescription(item)}`;
    const requestedLotX =
      itemX + font.widthOfTextAtSize(itemDescription, 8.5) + lotGap;
    const maximumLotX = Math.max(
      itemX + 40,
      MASK_ACCESSORY_QUANTITY_X -
        font.widthOfTextAtSize(lotText, 7.5) -
        10,
    );
    const lotX = lotText
      ? Math.min(requestedLotX, maximumLotX)
      : MASK_ACCESSORY_QUANTITY_X;

    drawField(
      itemDescription,
      itemX,
      itemY,
      lotX - itemX - lotGap,
      8.5,
      6,
    );
    drawField(
      lotText,
      lotX,
      itemY,
      MASK_ACCESSORY_QUANTITY_X - lotX - 10,
      7.5,
      6,
    );
    drawField(
      `จำนวน ${quantity}`,
      MASK_ACCESSORY_QUANTITY_X,
      itemY,
      contentRight - MASK_ACCESSORY_QUANTITY_X,
      8.5,
      7,
    );
  });

  drawField(patientName, 92, height - 380.58, 115, 8, 7);
  drawField(receiptDate, 95, height - 397.4, 105, 8.5, 7);
  drawField(receiptDate, 386, height - 397.4, 105, 8.5, 7);
};

const SaleOrderList = ({
  filesList: allFilesList,
  startAddFile,
  startSetFiles,
  setFiles,
}) => {
  const [loading, setLoading] = useState(true);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAddItemModal, setShowAddItemModal] = useState(false);
  const [availableAccessories, setAvailableAccessories] = useState([]);
  const [selectedAccessory, setSelectedAccessory] = useState(null);
  const [newItemQuantity, setNewItemQuantity] = useState(1);
  const [newItemPrice, setNewItemPrice] = useState(0);
  const [editingOrder, setEditingOrder] = useState(null);
  const fileOrder = showEditModal ? editingOrder : selectedOrder;
  const filesList = (allFilesList || []).filter((file) => fileOrder && (file.hn
    ? file.hn === String(fileOrder.hn || "").trim() && file.orderId === fileOrder.id
    : (fileOrder.items || []).some((item) => item.productType === "CPAP" && item.productId === file.productId)));
  const [accessoryPackageStatus, setAccessoryPackageStatus] = useState({});
  const [originalOrderItems, setOriginalOrderItems] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchName, setSearchName] = useState("");
  const [searchSourceOrders, setSearchSourceOrders] = useState([]);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [searchCurrentPage, setSearchCurrentPage] = useState(1);
  const [statusFilter, setStatusFilter] = useState("ทั้งหมด");
  const [salesFilter, setSalesFilter] = useState("ทั้งหมด");
  const [isImporting, setIsImporting] = useState(false);
  const fileInputRef = useRef(null);

  const statusSelect = [
    "ทั้งหมด",
    "เตรียมเครื่อง",
    "กำลังดำเนินการ",
    "รอเอกสาร",
    "เสร็จสิ้น",
  ];

  const [salesSelect, setSalesSelect] = useState(["ทั้งหมด"]);

  const onStatusChange = (option) => {
    setStatusFilter(option);
  };

  const onSalesChange = (option) => {
    setSalesFilter(option);
  };
  const [mailModal, setMailModal] = useState(false);
  const [emailList, setEmailList] = useState([]);
  const [selectEmail, setSelectEmail] = useState("");
  const [emailLoading, setEmailLoading] = useState(true);
  const [dataToSend, setDataToSend] = useState({});
  const { currentUser } = useAuth();

  // File management state
  const [fileUrl, setFileUrl] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [showFileModal, setShowFileModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [fileNames, setFileNames] = useState([]);

  // E-Slip state
  const [eSlipFile, setESlipFile] = useState(null);
  const [eSlipPreview, setESlipPreview] = useState(null);
  const [eSlipUploading, setESlipUploading] = useState(false);
  const [eSlipDeleting, setESlipDeleting] = useState(false);
  const eSlipBusy = eSlipUploading || eSlipDeleting;

  const getSignedUrl = httpsCallable(functions, "getSignedUrl");

  const itemPerPage = 50;

  const queryRef = useMemo(() => {
    const queryFilterConstraints = [];

    // Apply receipt number search filter
    if (searchText !== "") {
      queryFilterConstraints.push(
        where("receiptNo", ">=", searchText),
        where("receiptNo", "<=", searchText + "\uf8ff"),
      );
    }

    // Apply status filter
    if (statusFilter !== "ทั้งหมด") {
      queryFilterConstraints.push(where("status", "==", statusFilter));
    }

    // Apply sales rep filter
    if (salesFilter !== "ทั้งหมด") {
      const saleValues = getSaleValuesForQuery(salesFilter, salesSelect);

      if (saleValues.length === 1) {
        queryFilterConstraints.push(where("sales", "==", saleValues[0]));
      } else if (saleValues.length > 1) {
        queryFilterConstraints.push(where("sales", "in", saleValues));
      }
    }

    if (queryFilterConstraints.length > 0) {
      return query(
        collection(db, "saleOrders"),
        and(...queryFilterConstraints),
        orderBy("createdAt", "desc"),
      );
    }

    return query(
      collection(db, "saleOrders"),
      orderBy("createdAt", "desc"),
    );
  }, [searchText, statusFilter, salesFilter, salesSelect]);

  const {
    items: paginatedOrders,
    isLoading: isPaginationLoading,
    isStart: isPaginationStart,
    isEnd: isPaginationEnd,
    getPrev: getPaginationPrev,
    getNext: getPaginationNext,
    totalItems: paginatedTotalItems,
    totalPages: paginatedTotalPages,
    currentPage: paginatedCurrentPage,
    goToPage: goToPaginationPage,
  } = usePagination(queryRef, { limit: itemPerPage });

  const isBroadSearchActive = searchName.trim() !== "";

  useEffect(() => {
    if (!isBroadSearchActive) {
      setSearchSourceOrders([]);
      setIsSearchLoading(false);
      return undefined;
    }

    setIsSearchLoading(true);
    setSearchSourceOrders([]);

    const unsubscribe = onSnapshot(
      queryRef,
      (snapshot) => {
        setSearchSourceOrders(
          snapshot.docs.map((orderDoc) => ({
            ...orderDoc.data(),
            id: orderDoc.id,
          })),
        );
        setIsSearchLoading(false);
      },
      (error) => {
        console.error("Error loading sale orders for search:", error);
        setSearchSourceOrders([]);
        setIsSearchLoading(false);
      },
    );

    return unsubscribe;
  }, [isBroadSearchActive, queryRef]);

  const matchingSearchOrders = useMemo(
    () => filterSaleOrders(searchSourceOrders, searchName),
    [searchSourceOrders, searchName],
  );

  useEffect(() => {
    setSearchCurrentPage(1);
  }, [searchName, queryRef]);

  const searchTotalPages = Math.ceil(
    matchingSearchOrders.length / itemPerPage,
  );
  const effectiveSearchCurrentPage = Math.min(
    searchCurrentPage,
    Math.max(searchTotalPages, 1),
  );
  const searchPageStart = (effectiveSearchCurrentPage - 1) * itemPerPage;
  const searchedOrders = matchingSearchOrders.slice(
    searchPageStart,
    searchPageStart + itemPerPage,
  );

  const orders = isBroadSearchActive ? searchedOrders : paginatedOrders;
  const isLoading = isBroadSearchActive
    ? isSearchLoading
    : isPaginationLoading;
  const isStart = isBroadSearchActive
    ? effectiveSearchCurrentPage <= 1
    : isPaginationStart;
  const isEnd = isBroadSearchActive
    ? effectiveSearchCurrentPage >= searchTotalPages
    : isPaginationEnd;
  const totalItems = isBroadSearchActive
    ? matchingSearchOrders.length
    : paginatedTotalItems;
  const totalPages = isBroadSearchActive
    ? searchTotalPages
    : paginatedTotalPages;
  const currentPage = isBroadSearchActive
    ? effectiveSearchCurrentPage
    : paginatedCurrentPage;
  const getPrev = isBroadSearchActive
    ? () => setSearchCurrentPage((page) => Math.max(1, page - 1))
    : getPaginationPrev;
  const getNext = isBroadSearchActive
    ? () =>
        setSearchCurrentPage((page) => Math.min(searchTotalPages, page + 1))
    : getPaginationNext;
  const goToPage = isBroadSearchActive
    ? (page) => setSearchCurrentPage(page)
    : goToPaginationPage;

  const handleShowDetail = (order) => {
    setSelectedOrder(order);

    // Load files for CPAP items
    const cpapItem =
      order.items && order.items.find((item) => item.productType === "CPAP");
    setFiles([]);
    startSetFiles(cpapItem && cpapItem.productId, { hn: order.hn, orderId: order.id })
      .catch(() => swal("Error", "Failed to load sale documents", "error"));

    setShowDetailModal(true);
  };

  const handleESlipUpload = async (e) => {
    const file = e.target.files[0];
    e.target.value = ""; // Allow retrying the same file after a failed upload.
    if (!file || !editingOrder || eSlipBusy) return;

    setESlipUploading(true);
    try {
      const downloadURL = await uploadSaleOrderESlip(
        editingOrder,
        file,
        currentUser,
      );
      setESlipFile(file);
      setESlipPreview(downloadURL);
      setEditingOrder((prev) => ({ ...prev, eSlipUrl: downloadURL }));
      const cpapItem = (editingOrder.items || []).find((item) => item.productType === "CPAP");
      await startSetFiles(cpapItem && cpapItem.productId, { hn: editingOrder.hn, orderId: editingOrder.id });

      swal("Success", "E-Slip uploaded and saved successfully!", "success");
    } catch (error) {
      console.error("Error uploading e-slip:", error);
      swal("Error", error.message || "Failed to upload e-slip", "error");
    } finally {
      setESlipUploading(false);
    }
  };

  const applyAttachmentDeletion = (result) => {
    if (matchesSaleOrderAttachment(editingOrder.eSlipUrl, result.target)) {
      setEditingOrder((prev) => ({ ...prev, eSlipUrl: result.savedESlipUrl }));
      setESlipPreview(result.savedESlipUrl || null);
      setESlipFile(null);
    }
    if (result.documentId) {
      setFiles((filesList || []).reduce((files, file) => {
        if (file.id !== result.documentId) files.push(file);
        else if (result.remainingFiles.length) files.push({ ...file, cpapFile: result.remainingFiles });
        return files;
      }, []));
    }
  };

  const handleDeleteESlip = async () => {
    if (eSlipBusy || !editingOrder || !editingOrder.eSlipUrl) return;
    setESlipDeleting(true);
    try {
      const confirmed = await swal({
        title: "Delete E-Slip?",
        text: "This deletes the image and clears its saved order link immediately. This cannot be undone.",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      });
      if (!confirmed) return;
      const result = await deleteSaleOrderAttachment(editingOrder, currentUser);
      applyAttachmentDeletion(result);
      swal("Success", "E-Slip deleted.", "success");
    } catch (error) {
      console.error("Error deleting E-Slip:", error);
      swal("Error", "Failed to delete E-Slip. Please retry to complete deletion.", "error");
    } finally {
      setESlipDeleting(false);
    }
  };

  const handleEditOrder = (order) => {
    console.log("=== handleEditOrder called ===");
    console.log("Order to edit:", order);
    console.log("Order items:", order.items);
    setEditingOrder({ ...order });
    const originalItems = [...(order.items || [])];
    console.log("Setting original order items:", originalItems);
    setOriginalOrderItems(originalItems); // Store original items for comparison

    // Initialize package status for accessories from saved data or item properties
    const packageStatus = order.accessoryPackageStatus || {};
    if (order.items) {
      order.items.forEach((item, index) => {
        if (item.itemType === "Accessory" || item.productType !== "CPAP") {
          // Use saved package status first, then fall back to item property
          packageStatus[index] =
            packageStatus[index] !== undefined
              ? packageStatus[index]
              : item.isIncludedInPackage || false;
        }
      });
    }
    setAccessoryPackageStatus(packageStatus);

    // Load existing e-slip preview
    setESlipPreview(order.eSlipUrl || null);
    setESlipFile(null);

    // Load files for CPAP items
    const cpapItem =
      order.items && order.items.find((item) => item.productType === "CPAP");
    setFiles([]);
    startSetFiles(cpapItem && cpapItem.productId, { hn: order.hn, orderId: order.id })
      .catch(() => swal("Error", "Failed to load sale documents", "error"));

    setShowEditModal(true);
  };

  const handleExportOrder = async (order) => {
    const { cpapItems } = splitSaleOrderReceiptItems(order.items);
    const isCpapOrder = cpapItems.length > 0;
    const standaloneAccessoryItems = getStandaloneAccessoryReceiptItems(
      order.items,
      order.accessoryPackageStatus,
    );
    const hasAccessoryItems = standaloneAccessoryItems.length > 0;

    if (!isCpapOrder && !hasAccessoryItems) {
      swal("Error", "This order does not contain any items.", "error");
      return;
    }

    try {
      console.log(
        isCpapOrder && hasAccessoryItems
          ? "Exporting CPAP and accessories receipt forms:"
          : isCpapOrder
            ? "Exporting unified CPAP receipt and warranty form:"
            : "Exporting CPAP mask and accessories receipt form:",
        order,
      );

      const patientRef = doc(db, "patients", order.hn);
      const patientInfo = await getDoc(patientRef);
      if (!patientInfo.exists()) {
        swal("Error", "Patient information not found!", "error");
        return;
      }

      let cpapItemsForPdf = [];
      let accessories = [];
      if (isCpapOrder) {
        cpapItemsForPdf = await Promise.all(
          cpapItems.map(resolveCpapItemPdfDetails),
        );
        accessories = getSalePackageAccessories(order.salePackage);
        if (accessories.length > MAX_ACCESSORY_LINES) {
          throw new Error(
            "The selected sale package has more than " +
              MAX_ACCESSORY_LINES +
              " accessory lines.",
          );
        }
      }

      const [cpapTemplatePdf, accessoryTemplatePdf, fontResponse] =
        await Promise.all([
          isCpapOrder
            ? loadReceiptTemplate(
                CPAP_RECEIPT_TEMPLATE_URL,
                "Unable to load the CPAP receipt template.",
              )
            : Promise.resolve(null),
          hasAccessoryItems
            ? loadReceiptTemplate(
                MASK_ACCESSORY_RECEIPT_TEMPLATE_URL,
                "Unable to load the mask and accessories receipt template.",
              )
            : Promise.resolve(null),
          fetch(CPAP_RECEIPT_FONT_URL),
        ]);

      if (!fontResponse.ok) {
        throw new Error("Unable to load the Sarabun font.");
      }

      const fontBytes = await fontResponse.arrayBuffer();
      const pdfDoc = await PDFDocument.create();
      pdfDoc.registerFontkit(fontkit);
      const customFont = await pdfDoc.embedFont(fontBytes, { subset: true });
      const patient = patientInfo.data();

      if (isCpapOrder) {
        for (const cpapItem of cpapItemsForPdf) {
          const [page] = await pdfDoc.copyPages(cpapTemplatePdf, [0]);
          pdfDoc.addPage(page);
          drawCpapReceiptPage(
            page,
            customFont,
            order,
            patient,
            cpapItem,
            accessories,
          );
        }
      }

      if (hasAccessoryItems) {
        const totalPages = Math.ceil(
          standaloneAccessoryItems.length / MASK_ACCESSORY_ITEMS_PER_PAGE,
        );

        for (
          let itemOffset = 0;
          itemOffset < standaloneAccessoryItems.length;
          itemOffset += MASK_ACCESSORY_ITEMS_PER_PAGE
        ) {
          const [page] = await pdfDoc.copyPages(accessoryTemplatePdf, [0]);
          pdfDoc.addPage(page);
          drawMaskAccessoryReceiptPage(
            page,
            customFont,
            order,
            patient,
            standaloneAccessoryItems.slice(
              itemOffset,
              itemOffset + MASK_ACCESSORY_ITEMS_PER_PAGE,
            ),
            itemOffset,
            itemOffset / MASK_ACCESSORY_ITEMS_PER_PAGE + 1,
            totalPages,
          );
        }
      }

      const pdfDocBytes = await pdfDoc.save();
      const pdfUrl = URL.createObjectURL(
        new Blob([pdfDocBytes], { type: "application/pdf" }),
      );
      window.open(pdfUrl, "_blank");
    } catch (error) {
      console.error("Error exporting sale order PDF:", error);
      swal("Error", "Failed to export PDF. Please try again.", "error");
    }
  };

  const updateStockForOrderChanges = async (
    originalItems,
    currentItems,
    orderReceiptNo,
  ) => {
    console.log("=== updateStockForOrderChanges called ===");
    console.log("Original items:", originalItems);
    console.log("Current items:", currentItems);
    console.log("Order receipt no:", orderReceiptNo);

    const stockUpdates = [];
    const stockLogs = [];

    // Helper function to check if an item is an accessory
    const isAccessoryItem = (item) => {
      console.log("isAccessoryItem check for:", item.productName, {
        productType: item.productType,
        itemType: item.itemType,
        productId: item.productId,
      });

      // Check if it has itemType field set to "Accessory" (for new orders)
      // OR if productType is a common accessory category
      // OR if productType is not one of the main device types
      const accessoryTypes = [
        "Mask",
        "Tube",
        "Filter",
        "Hose",
        "Humidifier Chamber",
        "SD Card",
        "Battery",
      ];
      const mainDeviceTypes = ["CPAP", "Humidifier", "BiPAP", "APAP"];

      const result =
        item.itemType === "Accessory" ||
        accessoryTypes.includes(item.productType) ||
        (item.productType && !mainDeviceTypes.includes(item.productType));

      console.log("isAccessoryItem result:", result);
      return result;
    };

    // Find removed items (in original but not in current)
    const removedItems = originalItems.filter((originalItem) => {
      console.log("=== Checking item for removal ===");
      console.log("Original item:", originalItem);
      const isAccessory = isAccessoryItem(originalItem);
      const foundInCurrent = currentItems.find((currentItem) => {
        console.log(
          "Comparing with current item:",
          currentItem.productId,
          "vs",
          originalItem.productId,
        );
        return currentItem.productId === originalItem.productId;
      });
      console.log(
        "Is accessory:",
        isAccessory,
        "Found in current:",
        !!foundInCurrent,
      );
      const shouldRemove = isAccessory && !foundInCurrent;
      console.log("Should remove:", shouldRemove);
      return shouldRemove;
    });
    console.log("Removed items:", removedItems);

    // Find added items (in current but not in original)
    const addedItems = currentItems.filter((currentItem) => {
      console.log("Checking current item for addition:", currentItem);
      console.log(
        "Product type:",
        currentItem.productType,
        "Item type:",
        currentItem.itemType,
      );
      const isAccessory = isAccessoryItem(currentItem);
      const foundInOriginal = originalItems.find(
        (originalItem) => originalItem.productId === currentItem.productId,
      );
      console.log(
        "Is accessory:",
        isAccessory,
        "Found in original:",
        !!foundInOriginal,
      );
      return isAccessory && !foundInOriginal;
    });
    console.log("Added items:", addedItems);

    // Find quantity changed items
    const quantityChangedItems = [];
    currentItems.forEach((currentItem) => {
      if (isAccessoryItem(currentItem)) {
        const originalItem = originalItems.find(
          (orig) => orig.productId === currentItem.productId,
        );
        if (originalItem && originalItem.quantity !== currentItem.quantity) {
          quantityChangedItems.push({
            original: originalItem,
            current: currentItem,
            quantityDiff: currentItem.quantity - originalItem.quantity,
          });
        }
      }
    });
    console.log("Quantity changed items:", quantityChangedItems);

    // Process removed items - restore stock
    for (const item of removedItems) {
      if (isAccessoryItem(item)) {
        const accessoryDoc = await getDoc(
          doc(db, "accessories", item.productId),
        );
        if (accessoryDoc.exists()) {
          const currentStock = accessoryDoc.data().stockQuantity || 0;
          const newStock = currentStock + item.quantity;

          stockUpdates.push(
            updateDoc(doc(db, "accessories", item.productId), {
              stockQuantity: newStock,
              updatedAt: new Date(),
              updatedBy: currentUser.displayName || currentUser.email,
            }),
          );

          stockLogs.push({
            itemId: item.productId,
            itemName: item.productName,
            itemType: "Accessory",
            quantity: item.quantity, // Positive for returned items
            stockBefore: currentStock,
            stockAfter: newStock,
            type: "return",
            notes: `Order ${orderReceiptNo} edited - Item removed, stock restored`,
            createdBy: currentUser.displayName || currentUser.email,
          });
        }
      }
    }

    // Process added items - reduce stock
    for (const item of addedItems) {
      if (isAccessoryItem(item)) {
        const accessoryDoc = await getDoc(
          doc(db, "accessories", item.productId),
        );
        if (accessoryDoc.exists()) {
          const currentStock = accessoryDoc.data().stockQuantity || 0;
          const newStock = currentStock - item.quantity;

          if (newStock < 0) {
            throw new Error(
              `Insufficient stock for ${item.productName}. Available: ${currentStock}, Required: ${item.quantity}`,
            );
          }

          stockUpdates.push(
            updateDoc(doc(db, "accessories", item.productId), {
              stockQuantity: newStock,
              updatedAt: new Date(),
              updatedBy: currentUser.displayName || currentUser.email,
            }),
          );

          stockLogs.push({
            itemId: item.productId,
            itemName: item.productName,
            itemType: "Accessory",
            quantity: -item.quantity, // Negative for sold items
            stockBefore: currentStock,
            stockAfter: newStock,
            type: "sell",
            notes: `Order ${orderReceiptNo} edited - New item added`,
            createdBy: currentUser.displayName || currentUser.email,
          });
        }
      }
    }

    // Process quantity changed items
    for (const change of quantityChangedItems) {
      const accessoryDoc = await getDoc(
        doc(db, "accessories", change.current.productId),
      );
      if (accessoryDoc.exists()) {
        const currentStock = accessoryDoc.data().stockQuantity || 0;
        const newStock = currentStock - change.quantityDiff; // Negative diff means stock increases

        if (newStock < 0) {
          throw new Error(
            `Insufficient stock for ${change.current.productName}. Available: ${currentStock}, Additional required: ${change.quantityDiff}`,
          );
        }

        stockUpdates.push(
          updateDoc(doc(db, "accessories", change.current.productId), {
            stockQuantity: newStock,
            updatedAt: new Date(),
            updatedBy: currentUser.displayName || currentUser.email,
          }),
        );

        const changeType = change.quantityDiff > 0 ? "sell" : "return";
        const changeNote =
          change.quantityDiff > 0
            ? `Order ${orderReceiptNo} edited - Quantity increased by ${change.quantityDiff}`
            : `Order ${orderReceiptNo} edited - Quantity decreased by ${Math.abs(
                change.quantityDiff,
              )}`;

        stockLogs.push({
          itemId: change.current.productId,
          itemName: change.current.productName,
          itemType: "Accessory",
          quantity: -change.quantityDiff, // Negative for stock reduction
          stockBefore: currentStock,
          stockAfter: newStock,
          type: changeType,
          notes: changeNote,
          createdBy: currentUser.displayName || currentUser.email,
        });
      }
    }

    // Execute all stock updates
    console.log("Stock updates to execute:", stockUpdates.length);
    if (stockUpdates.length > 0) {
      console.log("Executing stock updates...");
      await Promise.all(stockUpdates);
      console.log("Stock updates completed");
    }

    // Create stock logs
    console.log("Stock logs to create:", stockLogs.length);
    if (stockLogs.length > 0) {
      console.log("Creating stock logs...", stockLogs);
      await createMultipleStockLogs(stockLogs);
      console.log("Stock logs created");
    }

    return {
      removedCount: removedItems.length,
      addedCount: addedItems.length,
      quantityChangedCount: quantityChangedItems.length,
    };
  };

  const handleSaveOrder = async () => {
    if (eSlipBusy) return;
    try {
      console.log("=== SAVE ORDER START ===");
      console.log("Saving order:", editingOrder);
      console.log("Original items:", originalOrderItems);
      console.log("Current items:", editingOrder.items);
      if (editingOrder.status === "ยกเลิก") {
        throw new Error("Use the Cancel order action so saved lot allocations are restored exactly.");
      }

      // Handle warranty start date conversion
      let warrantyStartDate = editingOrder.warrantyStartDate;
      if (typeof warrantyStartDate === "string") {
        warrantyStartDate = new Date(warrantyStartDate);
      } else if (warrantyStartDate && warrantyStartDate.toDate) {
        warrantyStartDate = warrantyStartDate.toDate();
      }

      // Recalculate the end date for the current supported warranty periods.
      let warrantyEndDate = editingOrder.warrantyEndDate;
      if (
        isSupportedWarrantyPeriod(editingOrder.warrantyPeriod) &&
        warrantyStartDate
      ) {
        warrantyEndDate = formatWarrantyDate(
          calculateWarrantyEndDate(
            editingOrder.warrantyPeriod,
            warrantyStartDate,
          ),
        );
      }

      // Handle warranty end date conversion
      if (typeof warrantyEndDate === "string") {
        warrantyEndDate = new Date(warrantyEndDate);
      } else if (warrantyEndDate && warrantyEndDate.toDate) {
        warrantyEndDate = warrantyEndDate.toDate();
      }

      // Handle receipt date conversion
      let receiptDate = editingOrder.receiptDate;
      if (typeof receiptDate === "string") {
        receiptDate = new Date(receiptDate);
      } else if (receiptDate && receiptDate.toDate) {
        receiptDate = receiptDate.toDate();
      }

      const updateData = {
        receiptNo: editingOrder.receiptNo,
        receiptDate: receiptDate,
        totalAmount: parseFloat(editingOrder.totalAmount) || 0,
        warrantyPeriod: editingOrder.warrantyPeriod,
        warrantyStartDate: warrantyStartDate,
        warrantyEndDate: warrantyEndDate,
        status: editingOrder.status,
        sales: editingOrder.sales,
        note: editingOrder.note || "",
        // E-Slip uploads/deletions persist separately; do not overwrite with a stale draft URL.
        items: editingOrder.items || [], // Include updated items array
        accessoryPackageStatus: accessoryPackageStatus, // Save package status
        refCustomer: editingOrder.refCustomer || "",
        refHospital: editingOrder.refHospital || "",
        nodeRef: editingOrder.nodeRef || "",
        mobile: editingOrder.mobile || "",
        updatedAt: new Date(),
        updatedBy: currentUser.displayName || currentUser.email,
      };

      console.log("Update data:", updateData);
      console.log("Original order items for stock update:", originalOrderItems);
      console.log("Current order items for stock update:", editingOrder.items);

      const originalAccessoryMap = new Map(
        originalOrderItems
          .filter(isAccessoryOrderItem)
          .map((item) => [item.productId, item]),
      );
      const currentAccessoryMap = new Map(
        (editingOrder.items || [])
          .filter(isAccessoryOrderItem)
          .map((item) => [item.productId, item]),
      );
      const stockChanges = isExcelImportedSaleOrder(editingOrder)
        ? { removedCount: 0, addedCount: 0, quantityChangedCount: 0 }
        : {
            removedCount: Array.from(originalAccessoryMap.keys()).filter(
              (id) => !currentAccessoryMap.has(id),
            ).length,
            addedCount: Array.from(currentAccessoryMap.keys()).filter(
              (id) => !originalAccessoryMap.has(id),
            ).length,
            quantityChangedCount: Array.from(
              currentAccessoryMap.entries(),
            ).filter(
              ([id, item]) =>
                originalAccessoryMap.has(id) &&
                Number(originalAccessoryMap.get(id).quantity) !==
                  Number(item.quantity),
            ).length,
          };
      const savedItems = await updateSaleOrderWithLots(
        db,
        editingOrder.id,
        updateData,
        currentUser,
      );
      updateData.items = savedItems;

      // Update product logs and patient order logs
      const logUpdatePromises = [];

      // Keep the Annual Mask source case in sync with the sale order. Its
      // ready-to-purchase notification disappears as soon as the order is
      // marked เสร็จสิ้น.
      if (editingOrder.annualMaskCasePath) {
        const annualMaskStatus = getAnnualMaskCaseStatusForSaleOrder(
          editingOrder.status,
        );
        const annualMaskUpdates = [
          updateDoc(doc(db, editingOrder.annualMaskCasePath), {
            saleOrderStatus: editingOrder.status,
            saleOrderReceiptNo: editingOrder.receiptNo,
            status: annualMaskStatus,
            updatedAt: new Date(),
            updatedBy: currentUser.displayName || currentUser.email || "",
          }),
        ];
        if (editingOrder.annualMaskSourceFollowupPath) {
          annualMaskUpdates.push(
            updateDoc(doc(db, editingOrder.annualMaskSourceFollowupPath), {
              "extendedProps.annualMaskPurchase.status": annualMaskStatus,
              "extendedProps.annualMaskPurchase.updatedAt": new Date(),
            }),
          );
        }
        logUpdatePromises.push(
          Promise.all(annualMaskUpdates).catch((error) => {
            console.warn("Unable to sync Annual Mask order status", error);
          }),
        );
      }

      // Update product logs for all CPAP items
      const cpapItems = editingOrder.items.filter(
        (item) => item.productType === "CPAP",
      );
      cpapItems.forEach((cpapItem) => {
        const productLogRef = doc(
          db,
          "products",
          cpapItem.productId,
          "logs",
          editingOrder.id,
        );
        logUpdatePromises.push(
          updateDoc(productLogRef, {
            activity: "purchase", // Keep the original activity
            status: editingOrder.status,
            createdAt: new Date(), // Update timestamp
            sales: editingOrder.sales,
          }).catch((error) => {
            // Log error but don't fail the entire operation if log update fails
            console.warn(
              `Failed to update product log for ${cpapItem.productId}:`,
              error,
            );
          }),
        );
      });

      // Update patient order log if there are CPAP items
      if (cpapItems.length > 0) {
        const patientOrderLogRef = doc(
          db,
          "patients",
          editingOrder.hn,
          "orders",
          editingOrder.id,
        );
        logUpdatePromises.push(
          updateDoc(patientOrderLogRef, {
            activity: "purchase", // Keep the original activity
            status: editingOrder.status,
            receiptDate: editingOrder.receiptDate,
            createdAt: new Date(), // Update timestamp
            sales: editingOrder.sales,
          }).catch((error) => {
            // Log error but don't fail the entire operation if log update fails
            console.warn(
              `Failed to update patient order log for ${editingOrder.hn}:`,
              error,
            );
          }),
        );
      }

      // Handle order cancellation - update CPAP status back to available
      if (editingOrder.status === "ยกเลิก") {
        cpapItems.forEach((cpapItem) => {
          const cpapRef = doc(db, "products", cpapItem.productId);
          logUpdatePromises.push(
            updateDoc(cpapRef, {
              status: "ว่าง", // Set back to available
              sales: "", // Clear sales person
              updatedAt: new Date(),
              updatedBy: currentUser.displayName || currentUser.email,
            }).catch((error) => {
              console.warn(
                `Failed to update CPAP status for ${cpapItem.productId}:`,
                error,
              );
            }),
          );
        });
      }

      // Execute all log updates (don't await to avoid blocking the UI)
      Promise.all(logUpdatePromises)
        .then(() => {
          console.log(
            "Product logs and patient order logs updated successfully",
          );
        })
        .catch((error) => {
          console.warn("Some log updates failed:", error);
        });

      setShowEditModal(false);
      setEditingOrder(null);
      setOriginalOrderItems([]); // Clear original items
      setESlipFile(null);
      setESlipPreview(null);

      const stockMessage =
        stockChanges.addedCount > 0 ||
        stockChanges.removedCount > 0 ||
        stockChanges.quantityChangedCount > 0
          ? ` Stock updated: ${stockChanges.addedCount} items added, ${stockChanges.removedCount} items removed, ${stockChanges.quantityChangedCount} quantities changed.`
          : "";

      swal("Success", `Order updated successfully!${stockMessage}`, "success");
    } catch (error) {
      console.error("Error updating order:", error);
      console.error("Error details:", error.message);
      swal("Error", `Failed to update order: ${error.message}`, "error");
    }
  };

  const handleSyncPatientData = async () => {
    try {
      if (!editingOrder || !editingOrder.hn) {
        swal("Error", "No patient HN found to sync data", "error");
        return;
      }

      // Get patient data from patients collection
      const patientRef = doc(db, "patients", editingOrder.hn);
      const patientDoc = await getDoc(patientRef);

      if (!patientDoc.exists()) {
        swal("Error", "Patient data not found", "error");
        return;
      }

      const patientData = patientDoc.data();

      // Update the editing order with fresh patient data
      setEditingOrder((prev) => ({
        ...prev,
        refCustomer: patientData.refCustomer || "",
        refHospital: patientData.refHn || "",
        nodeRef: patientData.nodeRef || "",
        mobile: patientData.mobile || "",
      }));

      swal("Success", "Patient data synced successfully!", "success");
    } catch (error) {
      console.error("Error syncing patient data:", error);
      swal("Error", "Failed to sync patient data", "error");
    }
  };

  const handleEditFieldChange = (field, value) => {
    console.log(`Updating field ${field} with value:`, value);
    setEditingOrder((prev) => {
      const updated = {
        ...prev,
        [field]: value,
      };

      // Auto-sync warranty dates when the receipt, start date, or period changes.
      if (field === "receiptDate") {
        if (isSupportedWarrantyPeriod(prev.warrantyPeriod)) {
          updated.warrantyStartDate = value;
          updated.warrantyEndDate = formatWarrantyDate(
            calculateWarrantyEndDate(
              prev.warrantyPeriod,
              value,
            ),
          );
        }
      } else if (field === "warrantyPeriod") {
        const warrantyStartDate = prev.warrantyStartDate || prev.receiptDate;
        if (isSupportedWarrantyPeriod(value) && warrantyStartDate) {
          updated.warrantyStartDate = warrantyStartDate;
          updated.warrantyEndDate = formatWarrantyDate(
            calculateWarrantyEndDate(value, warrantyStartDate),
          );
        }
      } else if (field === "warrantyStartDate") {
        if (isSupportedWarrantyPeriod(prev.warrantyPeriod)) {
          updated.warrantyEndDate = formatWarrantyDate(
            calculateWarrantyEndDate(prev.warrantyPeriod, value),
          );
        }
      }

      console.log("Updated editing order:", updated);
      return updated;
    });
  };

  const handleEditItemField = (itemIndex, field, value) => {
    console.log(
      `Updating item ${itemIndex}, field ${field} with value:`,
      value,
    );
    setEditingOrder((prev) => {
      const updatedItems = [...(prev.items || [])];
      updatedItems[itemIndex] = {
        ...updatedItems[itemIndex],
        [field]: value,
      };

      // Recalculate total amount when price changes, excluding accessories included in package
      const newTotalAmount = updatedItems.reduce((sum, item, idx) => {
        const isAccessory =
          item.itemType === "Accessory" || item.productType !== "CPAP";
        const isIncludedInPackage = isAccessory && accessoryPackageStatus[idx];

        if (!isIncludedInPackage) {
          return sum + (item.quantity || 1) * (item.price || 0);
        }
        return sum;
      }, 0);

      const updated = {
        ...prev,
        items: updatedItems,
        totalAmount: newTotalAmount,
      };
      console.log("Updated editing order with item changes:", updated);
      return updated;
    });
  };

  const handleRemoveItem = (index) => {
    swal({
      title: "Are you sure?",
      text: "This item will be removed from the order. Note: Stock adjustments need to be managed manually if required.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setEditingOrder((prev) => {
          const updatedItems = [...(prev.items || [])];
          const removedItem = updatedItems[index];
          console.log("=== Removing item ===");
          console.log("Removed item:", removedItem);
          console.log(
            "Updated items after removal:",
            updatedItems.filter((_, i) => i !== index),
          );
          updatedItems.splice(index, 1);

          // Recalculate total amount
          const newTotalAmount = updatedItems.reduce(
            (sum, item) => sum + (item.quantity || 1) * (item.price || 0),
            0,
          );

          console.log(
            `Removed item: ${removedItem.productName} (Qty: ${removedItem.quantity})`,
          );

          return {
            ...prev,
            items: updatedItems,
            totalAmount: newTotalAmount,
          };
        });

        swal(
          "Item removed!",
          "The item has been removed from the order. Remember to adjust stock manually if needed.",
          "success",
        );
      }
    });
  };

  const calculateOrderTotal = () => {
    if (!editingOrder || !editingOrder.items) return 0;
    return editingOrder.items.reduce((sum, item, index) => {
      // Check if this accessory is included in package
      const isAccessory =
        item.itemType === "Accessory" || item.productType !== "CPAP";
      const isIncludedInPackage = isAccessory && accessoryPackageStatus[index];

      // Only add to total if it's not an accessory included in package
      if (!isIncludedInPackage) {
        return sum + (item.quantity || 1) * (item.price || 0);
      }
      return sum;
    }, 0);
  };

  const loadAvailableAccessories = async () => {
    try {
      const accessoriesRef = collection(db, "accessories");
      const accessoriesQuery = query(
        accessoriesRef,
        where("stockQuantity", ">", 0),
        orderBy("itemName", "asc"),
      );
      const snapshot = await getDocs(accessoriesQuery);
      const accessories = [];
      snapshot.forEach((doc) => {
        accessories.push({
          id: doc.id,
          ...doc.data(),
        });
      });
      setAvailableAccessories(accessories);
    } catch (error) {
      console.error("Error loading accessories:", error);
    }
  };

  const handleAddNewItem = () => {
    if (!selectedAccessory) {
      swal("Error", "Please select an accessory to add", "error");
      return;
    }

    if (newItemQuantity > selectedAccessory.stockQuantity) {
      swal("Error", "Quantity cannot exceed available stock", "error");
      return;
    }

    const newItem = {
      productId: selectedAccessory.id,
      productName: selectedAccessory.itemName,
      productSn: selectedAccessory.itemCode,
      productBrand: selectedAccessory.brand,
      productType: selectedAccessory.category, // Use the actual category like "Mask", "Tube", etc.
      quantity: newItemQuantity,
      price: newItemPrice || 0,
      size: selectedAccessory.size || "",
      itemType: "Accessory",
    };

    console.log("=== Adding new item ===");
    console.log("New item:", newItem);

    setEditingOrder((prev) => {
      const updatedItems = [...(prev.items || []), newItem];
      console.log("Updated items after addition:", updatedItems);

      // Recalculate total amount
      const newTotalAmount = updatedItems.reduce(
        (sum, item) => sum + (item.quantity || 1) * (item.price || 0),
        0,
      );

      return {
        ...prev,
        items: updatedItems,
        totalAmount: newTotalAmount,
      };
    });

    // Reset form
    setSelectedAccessory(null);
    setNewItemQuantity(1);
    setNewItemPrice(0);
    setShowAddItemModal(false);

    swal("Success", "Accessory added to order!", "success");
  };

  const toggle = () => {
    setMailModal(!mailModal);
  };

  const handleOnSendMail = async (orderId) => {
    try {
      const orderData = orders.find((c) => c.id === orderId);

      if (!orderData || !orderData.items || orderData.items.length === 0) {
        swal("Error", "Order has no items to send", "error");
        return;
      }

      // Get patient information
      const patientRef = doc(db, "patients", orderData.hn);
      const patientInfo = await getDoc(patientRef);

      if (!patientInfo.exists()) {
        swal("Error", "Patient information not found", "error");
        return;
      }

      setDataToSend({
        ...orderData,
        nationalId: patientInfo.data().nationalId,
        address1: patientInfo.data().address1,
        address2: patientInfo.data().address2,
        province: patientInfo.data().province,
        postcode: patientInfo.data().postcode,
        healthInsurance: patientInfo.data().healthInsurance,
        mobile: patientInfo.data().mobile,
        updateHealthInsurance: patientInfo.data().updateHealthInsurance
          ? patientInfo.data().updateHealthInsurance
          : "",
        updateHealthInsuranceNote: patientInfo.data().updateHealthInsuranceNote
          ? patientInfo.data().updateHealthInsuranceNote
          : "",
      });

      toggle();
    } catch (error) {
      console.error("Error preparing email data:", error);
      swal("Error", "Failed to prepare order data", "error");
    }
  };

  const handleSendSubmit = async (isAll) => {
    try {
      // Build items list for email
      const itemsHtml = dataToSend.items
        .map(
          (item) =>
            `<p><strong>Brand</strong>: ${item.productBrand}<br/>
          <strong>${item.productType}</strong>: ${item.productName}<br/>
        <strong>Serial/Code</strong>: ${item.productSn}<br/>
        ${
          item.productBrand === "ResMed"
            ? `<strong>Device No</strong>: ${item.deviceNo || "N/A"}<br/>`
            : ""
        }
        <strong>Quantity</strong>: ${item.quantity}<br/>
        ${item.size ? `<strong>Size</strong>: ${item.size}<br/>` : ""}
        </p>`,
        )
        .join("<hr/>");

      // Use grand total from order details, fallback to totalAmount, then CPAP-only calculation
      const cpapTotal =
        dataToSend.grandTotal ||
        dataToSend.totalAmount ||
        dataToSend.items
          .filter((item) => item.productType === "CPAP")
          .reduce((sum, item) => sum + item.price * item.quantity, 0);

      const text = {
        to: `${isAll ? emailList : selectEmail}`,
        message: {
          subject: `Sale Order ${dataToSend.receiptNo} - ${dataToSend.firstname} ${dataToSend.lastname}`,
          html: `
          <h4>
          <strong>Sale Order No</strong>: ${dataToSend.receiptNo}<br/>
          <strong>Receipt Date</strong>: ${new Date(
            dataToSend.receiptDate.toDate
              ? dataToSend.receiptDate.toDate()
              : dataToSend.receiptDate,
          ).toLocaleString("th-TH", {
            day: "numeric",
            month: "short",
            year: "numeric",
          })}</h4>
          <div style="border:1px solid gray; padding-left:1rem; background-color:#eeeeee;">
            <h5>Customer Information</h5>
            <p><strong>Company HN</strong>: ${dataToSend.hn}<br/>
            <strong>Full Name</strong>: ${dataToSend.firstname} ${
              dataToSend.lastname
            }<br/>
            <strong>Address</strong>: ${dataToSend.address1} ${
              dataToSend.address2 || ""
            } ${dataToSend.province || ""} ${dataToSend.postcode || ""}<br/>
            <strong>Tel</strong>: ${dataToSend.mobile}<br/>
            <strong>National ID</strong>: ${dataToSend.nationalId}<br/>
            <strong>Ref Customer</strong>: ${
              dataToSend.refCustomer || "N/A"
            }<br/>
            <strong>Update Health Insurance</strong>: ${
              dataToSend.updateHealthInsurance || "-"
            }<br/>
            <strong>Update Note</strong>: ${
              dataToSend.updateHealthInsuranceNote || "-"
            }<br/>
            <strong>Ref Hospital</strong>: ${
              dataToSend.refHospital || "N/A"
            }<br/>
            <strong>Health Insurance</strong>: ${
              dataToSend.healthInsurance || "N/A"
            }<br/>
          </div>
          <br>
          <div style="border:1px solid gray; padding-left:1rem; background-color:#eeeeee;">
            <h5>Order Items (${dataToSend.items.length})</h5>
            ${itemsHtml}
          </div>
          <br>
          <div style="border:1px solid gray; padding-left:1rem; background-color:#eeeeee;">
            <h5>Order Summary</h5>
            <p><strong>Total Amount</strong>: ${cpapTotal} THB<br/>
            <strong>Status</strong>: ${dataToSend.status}<br/>
            <strong>Sales Representative</strong>: ${
              dataToSend.sales || "N/A"
            }<br/>
            <strong>Sale Package</strong>: ${
              dataToSend.salePackage || "N/A"
            }<br/>
            <strong>Warranty Period</strong>: ${
              dataToSend.warrantyPeriod || "N/A"
            }<br/>
            ${
              dataToSend.warrantyStartDate
                ? `<strong>Warranty Start</strong>: ${new Date(
                    dataToSend.warrantyStartDate.toDate
                      ? dataToSend.warrantyStartDate.toDate()
                      : dataToSend.warrantyStartDate,
                  ).toLocaleString("th-TH", {
                    day: "numeric",
                    month: "short",
                    year: "numeric",
                  })}<br/>`
                : ""
            }
            ${
              dataToSend.warrantyEndDate
                ? `<strong>Warranty End</strong>: ${new Date(
                    dataToSend.warrantyEndDate.toDate
                      ? dataToSend.warrantyEndDate.toDate()
                      : dataToSend.warrantyEndDate,
                  ).toLocaleString("th-TH", {
                    day: "numeric",
                    month: "short",
                    year: "numeric",
                  })}<br/>`
                : ""
            }
            </p>
          </div>
          <br>
          ${
            dataToSend.note
              ? `<p><strong>Note</strong>: ${dataToSend.note}</p>`
              : ""
          }
          ${
            dataToSend.eSlipUrl
              ? `<div style="border:1px solid gray; padding:1rem; background-color:#eeeeee;">
                  <h5>E-Slip Upload</h5>
                  <img src="${dataToSend.eSlipUrl}" alt="E-Slip" style="max-width:400px; max-height:400px;" />
                </div><br>`
              : ""
          }
          <p><strong>Submitted</strong>: ${currentUser.displayName}</p>
          `,
        },
      };

      await setDoc(doc(collection(db, "mail")), text);
      await updateDoc(doc(db, "saleOrders", dataToSend.id), {
        isMailSent: true,
        mailSentList: isAll ? emailList : selectEmail,
      });

      toggle();
      swal("Success", "Email sent successfully!", "success");
    } catch (error) {
      console.error("Error sending email:", error);
      swal("Error", "Failed to send email", "error");
    }
  };

  // File management functions
  const onFilesChange = async (e) => {
    const input = e.target;
    if (eSlipBusy) { input.value = null; return; }
    const files = [];
    for (let i = 0; i < e.target.files.length; i++) {
      const f = e.target.files[i];
      files.push(f);
    }
    if (files.length > 0 && editingOrder) {
      const data = {
        hn: String(editingOrder.hn || "").trim(),
        orderId: editingOrder.id,
        title: "Sale Documents",
        detail: `Order ${editingOrder.receiptNo || editingOrder.id}`,
        createBy: currentUser.displayName,
        createAt: new Date(),
      };
      if (data.hn && data.orderId) {
        setESlipUploading(true);
        try {
          await startAddFile(data, files);
          swal("Success", "Files uploaded successfully!", "success");
        } catch (error) {
          swal("Error", error.message || "Cannot upload files. Please try again.", "error");
        } finally {
          setESlipUploading(false);
        }
      } else {
        swal("Error", "Save the order with a patient HN before uploading files", "error");
      }
    }
    input.value = null; // Reset input
  };

  const onDeleteFile = async ({ productId, hn, id }) => {
    if (eSlipBusy || !editingOrder) return;
    setESlipDeleting(true);
    try {
      const willDelete = await swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this file! Its matching E-Slip order link will also be cleared.",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      });
      if (willDelete) {
        const result = await deleteSaleOrderAttachment(editingOrder, currentUser, { productId, hn, id });
        applyAttachmentDeletion(result);
        swal("Success", "File has been deleted!", "success");
      }
    } catch (error) {
      console.error("Error deleting CPAP sale document:", error);
      swal("Error", "Failed to delete file", "error");
    } finally {
      setESlipDeleting(false);
    }
  };

  const onViewFile = (productId, id, file) => {
    const attachment = (filesList || []).find((item) => item.id === id);
    getSignedUrl({
      folder: attachment && attachment.hn ? "patientcpapfiles" : "cpapfiles",
      hn: attachment && attachment.hn ? attachment.hn : productId,
      id,
      filename: file,
    })
      .then((result) => {
        setFileUrl(result.data);
        // Determine file type based on file extension
        const fileExtension = file.split(".").pop().toLowerCase();
        if (
          ["jpg", "jpeg", "png", "gif", "bmp", "svg"].includes(fileExtension)
        ) {
          setFileType("image");
        } else if (fileExtension === "pdf") {
          setFileType("pdf");
        } else {
          // Default to pdf viewer for other document types
          setFileType("pdf");
        }
        setShowFileModal(true);
      })
      .catch((error) => {
        console.log(error);
        swal("Error", "Failed to load file", "error");
      });
  };

  const onDownloadFile = (productId, id, file) => {
    const attachment = (filesList || []).find((item) => item.id === id);
    getSignedUrl({
      folder: attachment && attachment.hn ? "patientcpapfiles" : "cpapfiles",
      hn: attachment && attachment.hn ? attachment.hn : productId,
      id,
      filename: file,
    })
      .then((result) => {
        fetch(result.data).then((res) => {
          res.blob().then((blob) => {
            // Creating new object of PDF file
            const fileURL = window.URL.createObjectURL(blob);
            // Setting various property values
            let alink = document.createElement("a");
            alink.href = fileURL;
            alink.download = file;
            alink.click();
          });
        });
      })
      .catch((error) => {
        console.log(error);
        swal("Error", "Failed to download file", "error");
      });
  };

  const handleDeleteOrder = (orderId) => {
    swal({
      title: "Are you sure?",
      text: "Once order is cancelled, the record will be deleted. CPAP devices will be returned to 'ว่าง' status and accessory stock will be restored.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const orderDoc = orders.find((o) => o.id === orderId);

          if (!orderDoc || !orderDoc.items) {
            throw new Error("Order not found or has no items");
          }

          await cancelSaleOrderWithLots(db, orderDoc, currentUser);

          if (orderDoc.annualMaskCasePath) {
            try {
              await updateDoc(doc(db, orderDoc.annualMaskCasePath), {
                saleOrderId: "",
                saleOrderReceiptNo: "",
                saleOrderStatus: "",
                saleOrderCancelledAt: new Date(),
                saleOrderCancelledBy:
                  currentUser.displayName || currentUser.email || "",
                status: ANNUAL_MASK_STATUS.READY_TO_PURCHASE,
                updatedAt: new Date(),
                updatedBy: currentUser.displayName || currentUser.email || "",
              });
              if (orderDoc.annualMaskSourceFollowupPath) {
                await updateDoc(
                  doc(db, orderDoc.annualMaskSourceFollowupPath),
                  {
                    "extendedProps.annualMaskPurchase.status":
                      ANNUAL_MASK_STATUS.READY_TO_PURCHASE,
                    "extendedProps.annualMaskPurchase.updatedAt": new Date(),
                  },
                );
              }
            } catch (annualMaskError) {
              console.warn(
                "Sale order was cancelled but Annual Mask case could not be relinked",
                annualMaskError,
              );
            }
          }

          swal(
            "Order cancelled successfully!",
            "The CPAP status and applicable accessory stock have been reverted.",
            "success",
          );
        } catch (error) {
          console.error("Error cancelling order:", error);
          swal("Error", `Failed to cancel order: ${error.message}`, "error");
        }
      }
    });
  };

  const formatDate = (date) => {
    if (!date) return "N/A";
    const dateObj = date.toDate ? date.toDate() : new Date(date);
    return dateObj.toLocaleString("th-TH", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("th-TH", {
      style: "currency",
      currency: "THB",
    }).format(amount || 0);
  };

  const getStatusBadgeVariant = (status) => {
    switch (status) {
      case "เสร็จสิ้น":
        return "success";
      case "กำลังดำเนินการ":
        return "primary";
      case "รอเอกสาร":
        return "warning";
      case "เตรียมเครื่อง":
        return "info";
      default:
        return "secondary";
    }
  };

  useEffect(() => {
    const loadEmailList = async () => {
      setEmailLoading(true);
      try {
        const docRef = collection(db, "accountants");
        const snapshot = await getDocs(docRef);
        const data = [];

        snapshot.forEach((childSnapshot) => {
          data.push({
            ...childSnapshot.data(),
          });
        });

        const list = data
          .filter((item) => item.status === "Available")
          .map((item) => item.email);

        setEmailList(list);
        setSelectEmail(list[0] || "");
      } catch (error) {
        console.error("Error loading email list:", error);
      } finally {
        setEmailLoading(false);
      }
    };

    loadEmailList();
  }, []);

  // Load sales representatives from Firestore
  useEffect(() => {
    const loadSalesReps = async () => {
      try {
        const salesQuery = query(
          collection(db, "sales"),
          where("status", "==", "Available"),
        );
        const salesSnapshot = await getDocs(salesQuery);
        const salesList = salesSnapshot.docs.map((doc) => doc.data().name);
        setSalesSelect(["ทั้งหมด", ...salesList]);
      } catch (error) {
        console.error("Error loading sales representatives:", error);
      }
    };

    loadSalesReps();
  }, []);

  const parseThaiDate = (str) => {
    if (!str) return null;
    if (typeof str === "number") {
      const parsed = XLSX.SSF.parse_date_code(str);
      if (!parsed) return null;
      let year = parsed.y;
      if (year > 2400) year -= 543;
      return new Date(Date.UTC(year, parsed.m - 1, parsed.d));
    }
    const parts = String(str).split("/");
    if (parts.length !== 3) return null;
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);
    let year = parseInt(parts[2], 10);
    if (isNaN(day) || isNaN(month) || isNaN(year)) return null;
    if (year > 2400) year -= 543;
    return new Date(year, month - 1, day);
  };

  const splitThaiName = (fullname) => {
    const name = String(fullname || "").trim();
    if (!name) return { firstname: "", lastname: "" };
    const idx = name.indexOf(" ");
    if (idx === -1) return { firstname: name, lastname: "" };
    return {
      firstname: name.slice(0, idx).trim(),
      lastname: name.slice(idx + 1).trim(),
    };
  };

  const extractBrand = (packageName) => {
    const name = String(packageName || "").trim();
    if (!name) return "";
    const first = name.split(/\s|-/)[0];
    return first.trim();
  };

  const checkDuplicateReceipt = async (receiptNo) => {
    if (!receiptNo) return false;
    const q = query(
      collection(db, "saleOrders"),
      where("receiptNo", "==", receiptNo)
    );
    const snap = await getDocs(q);
    return !snap.empty;
  };

  const buildItems = (row, amountNum, accessoryMap, cpapProductId = "") => {
    const items = [];
    const accessoryPackageStatus = {};
    const pkg = String(row.package || "").trim();
    const sn = String(row.serialNumber || "").trim();
    const filter = String(row.filter || "").trim();
    const mask = String(row.mask || "").trim();
    const size = String(row.size || "").trim();
    const filterQty = Number(row.filterQty) || 1;
    const maskQty = Number(row.maskQty) || 1;

    const hasPackage = !!pkg;
    const hasCpap = pkg && sn;
    const hasFilter = !!filter;
    const hasMask = !!mask;

    const lookupAccessory = (name) => {
      const key = String(name || "").trim().toLowerCase();
      if (!key || !accessoryMap) return null;
      return accessoryMap.get(key) || null;
    };

    if (hasCpap) {
      items.push({
        productId: cpapProductId,
        productName: pkg,
        productSn: sn,
        price: amountNum,
        quantity: 1,
        size: "",
        productBrand: extractBrand(pkg),
        productType: "CPAP",
      });
    }

    if (hasFilter) {
      const acc = lookupAccessory(filter);
      items.push({
        productId: acc ? acc.id : "",
        productName: acc ? acc.itemName : filter,
        productSn: acc ? (acc.itemCode || "") : "",
        price: acc ? (Number(acc.unitPrice) || 0) : 0,
        quantity: filterQty,
        size: "",
        productBrand: acc ? (acc.brand || "") : "",
        productType: acc ? (acc.category || "Filter") : "Filter",
        itemType: "Accessory",
      });
      accessoryPackageStatus[items.length - 1] = hasPackage;
    }

    if (hasMask) {
      const acc = lookupAccessory(mask);
      items.push({
        productId: acc ? acc.id : "",
        productName: acc ? acc.itemName : mask,
        productSn: acc ? (acc.itemCode || "") : "",
        price: acc ? (Number(acc.unitPrice) || 0) : 0,
        quantity: maskQty,
        size: size,
        productBrand: acc ? (acc.brand || "") : "",
        productType: acc ? (acc.category || "Mask") : "Mask",
        itemType: "Accessory",
      });
      accessoryPackageStatus[items.length - 1] = hasPackage;
    }

    return { items, accessoryPackageStatus };
  };

  const handleImportClick = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  };

  const handleImportExcel = (event) => {
    const file = event.target.files[0];
    if (!file) {
      swal("Warning", "No file selected", "warning");
      return;
    }

    setIsImporting(true);
    const reader = new FileReader();

    reader.onload = async (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const allRows = XLSX.utils.sheet_to_json(worksheet, {
          header: 1,
          defval: null,
        });

        // แถว 0 = title, แถว 1 = header, data = slice(2)
        const dataRows = allRows.slice(2);

        const mappedRows = dataRows
          .map((r) => ({
            receiptNo: r[1] != null ? String(r[1]).trim() : "",
            receiptDateRaw: r[2],
            healthInsurance: r[3] != null ? String(r[3]).trim() : "",
            sleepStudyOrder: r[4] != null ? String(r[4]).trim() : "",
            refHospitalName: r[5] != null ? String(r[5]).trim() : "",
            fullname: r[6] != null ? String(r[6]).trim() : "",
            refHospital: r[7] != null ? String(r[7]).trim() : "",
            hn: r[8] != null ? String(r[8]).trim() : "",
            mobile: r[9] != null ? String(r[9]).trim() : "",
            package: r[10] != null ? String(r[10]).trim() : "",
            serialNumber: r[11] != null ? String(r[11]).trim() : "",
            filter: r[12] != null ? String(r[12]).trim() : "",
            filterQty: r[13],
            mask: r[14] != null ? String(r[14]).trim() : "",
            size: r[15] != null ? String(r[15]).trim() : "",
            maskQty: r[16],
            sales: r[17] != null ? String(r[17]).trim() : "",
            amount: r[18],
            status: r[19] != null ? String(r[19]).trim() : "",
            note: r[20] != null ? String(r[20]).trim() : "",
          }))
          .filter((r) => r.receiptNo !== "");

        // pre-fetch accessories ครั้งเดียวสำหรับ lookup ใน items
        const accSnap = await getDocs(collection(db, "accessories"));
        const accessoryMap = new Map();
        accSnap.forEach((d) => {
          const data = d.data();
          const key = String(data.itemName || "").trim().toLowerCase();
          if (key && !accessoryMap.has(key)) {
            accessoryMap.set(key, { id: d.id, ...data });
          }
        });

        // pre-fetch serialNumbers ที่มีอยู่แล้วใน products เพื่อเช็ค duplicate
        const productsSnap = await getDocs(collection(db, "products"));
        const existingProductsBySn = new Map();
        productsSnap.forEach((d) => {
          const sn = d.data().serialNumber;
          const normalizedSn = String(sn || "").trim();
          if (normalizedSn && !existingProductsBySn.has(normalizedSn)) {
            existingProductsBySn.set(normalizedSn, d.id);
          }
        });

        const successList = [];
        const failedList = [];
        const existedList = [];
        const productCreatedList = [];
        const productSkippedList = [];

        for (const row of mappedRows) {
          try {
            const duplicate = await checkDuplicateReceipt(row.receiptNo);
            if (duplicate) {
              existedList.push(row.receiptNo);
              continue;
            }

            const amountNum = Number(row.amount) || 0;
            const pkgName = String(row.package || "").trim();
            const snValue = String(row.serialNumber || "").trim();
            const existingProductId = existingProductsBySn.get(snValue) || "";
            const newProductRef =
              snValue && pkgName && !existingProductId
                ? doc(collection(db, "products"))
                : null;
            const cpapProductId =
              existingProductId || (newProductRef ? newProductRef.id : "");
            const { items, accessoryPackageStatus } = buildItems(
              row,
              amountNum,
              accessoryMap,
              cpapProductId,
            );
            const { firstname, lastname } = splitThaiName(row.fullname);
            const receiptDateParsed = parseThaiDate(row.receiptDateRaw);
            const warrantyEndDate = calculateWarrantyEndDate(
              DEFAULT_WARRANTY_PERIOD,
              receiptDateParsed,
            );
            const now = new Date();
            const createdBy =
              (currentUser &&
                (currentUser.displayName || currentUser.email)) ||
              "";

            const orderData = {
              receiptNo: row.receiptNo,
              hn: row.hn,
              firstname,
              lastname,
              items,
              totalAmount: amountNum,
              receiptDate: receiptDateParsed,
              status: row.status,
              sales: row.sales,
              salePackage: row.package,
              note: row.note,
              refCustomer: "",
              refHospital: row.refHospital,
              nodeRef: "",
              mobile: row.mobile,
              warrantyPeriod: DEFAULT_WARRANTY_PERIOD,
              warrantyStartDate: receiptDateParsed || null,
              warrantyEndDate,
              accessoryPackageStatus,
              healthInsurance: row.healthInsurance,
              sleepStudyOrder: row.sleepStudyOrder,
              refHospitalName: row.refHospitalName,
              createdAt: now,
              createdBy: createdBy,
              updatedAt: now,
              updatedBy: createdBy,
            };

            const orderRef = doc(collection(db, "saleOrders"));
            const importBatch = writeBatch(db);
            importBatch.set(orderRef, { ...orderData, id: orderRef.id });

            if (newProductRef) {
              importBatch.set(newProductRef, {
                serialNumber: snValue,
                brand: extractBrand(pkgName),
                model: "-",
                description: "",
                type: "",
                vendor: "",
                deviceNo: "",
                lotNo: "",
                incomingDate: null,
                status: "ขาย",
                note: "",
                sales: row.sales || "",
                soldDate: receiptDateParsed || now,
                soldTo: row.hn || "",
                createdBy: createdBy,
                createdAt: now,
                updatedAt: now,
                id: newProductRef.id,
                images: [],
              });
            }

            await importBatch.commit();
            successList.push(row.receiptNo);

            if (existingProductId) {
              productSkippedList.push(snValue);
            } else if (newProductRef) {
              existingProductsBySn.set(snValue, newProductRef.id);
              productCreatedList.push(snValue);
            }
          } catch (err) {
            console.log("import row failed:", row.receiptNo, err);
            failedList.push(row.receiptNo);
          }
        }

        const summary =
          `นำเข้า order สำเร็จ ${successList.length} รายการ` +
          `\nสร้าง product ใหม่ ${productCreatedList.length} เครื่อง` +
          (productSkippedList.length
            ? `\nProduct ซ้ำ (skip) ${productSkippedList.length} เครื่อง`
            : "") +
          (existedList.length
            ? `\nOrder ซ้ำ ${existedList.length}: ${existedList.join(", ")}`
            : "") +
          (failedList.length
            ? `\nOrder ล้มเหลว ${failedList.length}: ${failedList.join(", ")}`
            : "");

        if (failedList.length > 0 || existedList.length > 0) {
          swal("Imported with issues", summary, "warning");
        } else {
          swal("Success", summary, "success");
        }
      } catch (err) {
        console.log("import error:", err);
        swal("Error", "นำเข้าไฟล์ผิดพลาด กรุณาตรวจสอบไฟล์", "error");
      } finally {
        setIsImporting(false);
        if (event.target) event.target.value = null;
      }
    };

    reader.readAsArrayBuffer(file);
  };

  return (
    <Fragment>
      <PageTitle activeMenu="Sale Order List" motherMenu="Sales" />
      <div className="form-head d-flex mb-3 mb-lg-5 align-items-start justify-content-end">
        {/* Filters */}
        {/* <Card className="mb-4">
        <Card.Header>
          <h5>Search & Filters</h5>
        </Card.Header>
        <Card.Body> */}
        <div className="row">
          {/* <div className="d-flex justify-content-end"> */}
          <div className="col-lg-3 col-md-6">
            <div className="form-group">
              <input
                type="text"
                className="form-control"
                placeholder="IGCXXXXXXX"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="form-group">
              <input
                type="text"
                className="form-control"
                placeholder="Search HN, serial number, or patient name"
                value={searchName}
                onChange={(e) => setSearchName(e.target.value)}
              />
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="form-group">
              <Dropdown className="width200" onSelect={onStatusChange}>
                <Dropdown.Toggle variant="outline-primary" id="dropdown-status">
                  <i className="flaticon-381-controls-3 "></i> Status{" "}
                  {statusFilter}
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropdown-menu-right">
                  {statusSelect.map((element, index) => (
                    <Dropdown.Item href="#" eventKey={element} key={index}>
                      {element}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="form-group">
              <Dropdown className="width200" onSelect={onSalesChange}>
                <Dropdown.Toggle variant="outline-primary" id="dropdown-sales">
                  <i className="flaticon-381-controls-3 "></i> Sales{" "}
                  {salesFilter}
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropdown-menu-right">
                  {salesSelect.map((element, index) => (
                    <Dropdown.Item href="#" eventKey={element} key={index}>
                      {element}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
        {/* </Card.Body>
      </Card> */}
      </div>
      {/* Order List */}
      <Card>
        <Card.Header className="d-flex justify-content-between align-items-center">
          <h5>Sale Orders ({totalItems} items)</h5>
          <div className="d-flex align-items-center">
            <Button
              variant="primary"
              size="sm"
              onClick={handleImportClick}
              disabled={isImporting}
              className="mr-3"
            >
              {isImporting ? "กำลังนำเข้า..." : "Import .xlsx"}
            </Button>
            <input
              type="file"
              accept=".xlsx,.xls"
              ref={fileInputRef}
              onChange={handleImportExcel}
              style={{ display: "none" }}
            />
            <span>
              Page {currentPage} of {totalPages}
            </span>
          </div>
        </Card.Header>
        <Card.Body>
          {isLoading ? (
            <div className="text-center">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            <div className="table-responsive">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Receipt No</th>
                    <th>Serial Number</th>
                    <th>Patient</th>
                    <th>HN</th>
                    <th>Qty</th>
                    <th>Total Amount</th>
                    <th>Status</th>
                    <th>Receipt Date</th>
                    <th>Sales Rep</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map((order) => (
                    <tr key={order.id}>
                      <td>
                        {order.isMailSent && <i className="fa fa-send"></i>}{" "}
                        <Link
                          to="#"
                          onClick={() => handleShowDetail(order)}
                          // className="text-primary"
                          style={{ textDecoration: "none" }}
                        >
                          {order.receiptNo}
                        </Link>
                      </td>
                      <td>
                        {order.items && order.items.length > 0
                          ? (() => {
                              const cpapItems = order.items
                                .filter((item) => item.productType === "CPAP")
                                .filter((item) => item.productSn);

                              if (cpapItems.length === 0) return "";

                              return cpapItems.map((item, index) => (
                                <span key={index}>
                                  {index > 0 && ", "}
                                  <Link to={`/product-page/${item.productSn}`}>
                                    {item.productSn}
                                  </Link>
                                </span>
                              ));
                            })()
                          : ""}
                      </td>
                      <td>
                        {order.firstname} {order.lastname}
                      </td>
                      <td>
                        <Link to={getPatientPagePath(order.hn)}>
                          {order.hn}
                        </Link>
                      </td>
                      <td>
                        <Badge variant="info">
                          {order.items ? order.items.length : 0}
                        </Badge>
                      </td>
                      <td>{formatCurrency(order.totalAmount)}</td>
                      <td>
                        <Badge variant={getStatusBadgeVariant(order.status)}>
                          {order.status}
                        </Badge>
                      </td>
                      <td>{formatDate(order.receiptDate)}</td>
                      <td>{order.sales || "N/A"}{order.maskReceiptDate && <div className="small"><AnnualMaskReceiptDateText date={order.maskReceiptDate} /></div>}</td>
                      <td>
                        <Link
                          className="btn btn-primary shadow btn-xs sharp mr-2"
                          to="#"
                          data-toggle="tooltip"
                          data-placement="top"
                          title={
                            order.items &&
                            order.items.some(
                              (item) => item.productType === "CPAP",
                            )
                              ? "Export Order Receipt and Warranty"
                              : "Export Mask and Accessories Receipt"
                          }
                          onClick={() => handleExportOrder(order)}
                        >
                          <i className="fa fa-file-pdf-o"></i>
                        </Link>

                        <Link
                          className="btn btn-info shadow btn-xs sharp mr-2"
                          to="#"
                          onClick={() => handleEditOrder(order)}
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Edit order"
                        >
                          <i className="fa fa-pencil"></i>
                        </Link>

                        <Link
                          to="#"
                          className="btn btn-success shadow btn-xs sharp mr-2"
                          onClick={() => handleOnSendMail(order.id)}
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Email to Accountant"
                        >
                          <i className="fa fa-send"></i>
                        </Link>
                        <Link
                          to="#"
                          className="btn btn-danger shadow btn-xs sharp"
                          onClick={() => handleDeleteOrder(order.id)}
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Cancel order"
                        >
                          <i className="fa fa-close"></i>
                        </Link>
                      </td>
                    </tr>
                  ))}
                  {orders.length === 0 && (
                    <tr>
                      <td colSpan="10" className="text-center text-muted">
                        No orders found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          )}

          {/* Pagination */}
          {!isLoading && totalPages > 1 && (
            <div className="d-flex justify-content-between align-items-center mt-3">
              <Button
                variant="outline-primary"
                disabled={isStart}
                onClick={getPrev}
              >
                Previous
              </Button>
              <div className="d-flex">
                {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                  const pageNum = Math.max(1, currentPage - 2) + i;
                  if (pageNum <= totalPages) {
                    return (
                      <Button
                        key={pageNum}
                        variant={
                          pageNum === currentPage
                            ? "primary"
                            : "outline-primary"
                        }
                        size="sm"
                        className="mx-1"
                        onClick={() => goToPage(pageNum)}
                      >
                        {pageNum}
                      </Button>
                    );
                  }
                  return null;
                })}
              </div>
              <Button
                variant="outline-primary"
                disabled={isEnd}
                onClick={getNext}
              >
                Next
              </Button>
            </div>
          )}
        </Card.Body>
      </Card>

      {/* Order Detail Modal */}
      <Modal
        show={showDetailModal}
        onHide={() => setShowDetailModal(false)}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Order Details - {selectedOrder && selectedOrder.receiptNo}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedOrder && (
            <div>
              {/* Customer Information */}
              <Card className="mb-3">
                <Card.Header>
                  <h6>Customer Information</h6>
                </Card.Header>
                <Card.Body>
                  <div className="row">
                    <div className="col-md-6">
                      <p>
                        <strong>HN:</strong> {selectedOrder.hn}
                      </p>
                      <p>
                        <strong>Name:</strong> {selectedOrder.firstname}{" "}
                        {selectedOrder.lastname}
                      </p>
                      <p>
                        <strong>Reference Customer:</strong>{" "}
                        {selectedOrder.refCustomer || "N/A"}
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <strong>Reference Hospital:</strong>{" "}
                        {selectedOrder.refHospital || "N/A"}
                      </p>
                      <p>
                        <strong>Sales Representative:</strong>{" "}
                        {selectedOrder.sales || "N/A"}
                        {selectedOrder.maskReceiptDate && <span className="d-block"><AnnualMaskReceiptDateText date={selectedOrder.maskReceiptDate} /></span>}
                      </p>
                      <p>
                        <strong>Status:</strong>{" "}
                        <Badge
                          variant={getStatusBadgeVariant(selectedOrder.status)}
                        >
                          {selectedOrder.status}
                        </Badge>
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>

              {/* CPAP Sale Documents */}
              {(selectedOrder.hn || (selectedOrder.items || []).some((item) => item.productType === "CPAP")) && (
                  <Card className="mb-3">
                    <Card.Header>
                      <h6>CPAP Sale Documents</h6>
                    </Card.Header>
                    <Card.Body>
                      {filesList && filesList.length > 0 ? (
                        <div>
                          <div className="timeline">
                            {filesList.map((item, index) => (
                              // <div key={item.id} className="border rounded p-3 mb-2">
                              <div className="d-flex justify-content-between align-items-center">
                                <div className="flex-grow-1">
                                  <div className="row">
                                    {item.cpapFile &&
                                      item.cpapFile.map((file, fileIndex) => (
                                        <div
                                          key={fileIndex}
                                          className="mb-2 d-inline-block mr-2"
                                        >
                                          <Badge
                                            variant="outline-light"
                                            className="p-2 text-left"
                                            style={{
                                              cursor: "pointer",
                                              maxWidth: "300px",
                                              wordWrap: "break-word",
                                              whiteSpace: "normal",
                                              display: "inline-block",
                                            }}
                                            onClick={() =>
                                              onViewFile(
                                                selectedOrder.items &&
                                                  selectedOrder.items.find(
                                                    (i) =>
                                                      i.productType === "CPAP",
                                                  ) &&
                                                  selectedOrder.items.find(
                                                    (i) =>
                                                      i.productType === "CPAP",
                                                  ).productId,
                                                item.id,
                                                file,
                                              )
                                            }
                                          >
                                            <i className="fa fa-file mr-2"></i>
                                            {file}
                                          </Badge>
                                        </div>
                                      ))}
                                  </div>
                                </div>
                                <div className="text-right">
                                  <small className="text-muted">
                                    <div>
                                      Created by:{" "}
                                      <strong>{item.createBy}</strong>
                                    </div>
                                    <div>
                                      {new Date(
                                        item.createAt && item.createAt.toDate
                                          ? item.createAt.toDate()
                                          : item.createAt,
                                      ).toLocaleString()}
                                    </div>
                                  </small>
                                </div>
                              </div>
                              // </div>
                            ))}
                          </div>
                        </div>
                      ) : (
                        <div className="text-center text-muted py-3">
                          <p>No documents uploaded for this order</p>
                        </div>
                      )}
                    </Card.Body>
                  </Card>
                )}

              {/* Order Information */}
              <Card className="mb-3">
                <Card.Header>
                  <h6>Order Information</h6>
                </Card.Header>
                <Card.Body>
                  <div className="row">
                    <div className="col-md-6">
                      <p>
                        <strong>Receipt Date:</strong>{" "}
                        {formatDate(selectedOrder.receiptDate)}
                      </p>
                      <p>
                        <strong>Warranty Period:</strong>{" "}
                        {selectedOrder.warrantyPeriod || "N/A"}
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <strong>Warranty Start:</strong>{" "}
                        {formatDate(selectedOrder.warrantyStartDate)}
                      </p>
                      <p>
                        <strong>Warranty End:</strong>{" "}
                        {formatDate(selectedOrder.warrantyEndDate)}
                      </p>
                    </div>
                  </div>
                  {selectedOrder.note && (
                    <p>
                      <strong>Note:</strong> {selectedOrder.note}
                    </p>
                  )}
                </Card.Body>
              </Card>

              {/* Items */}
              <Card>
                <Card.Header>
                  <h6>
                    Items (
                    {selectedOrder.items ? selectedOrder.items.length : 0})
                  </h6>
                </Card.Header>
                <Card.Body>
                  <Table striped bordered size="sm">
                    {/* <table className="table table-striped"> */}
                    <thead>
                      <tr>
                        <th>Incl.</th>
                        <th>Product Name</th>
                        <th>Serial/Code</th>
                        <th>Brand</th>
                        <th>Type</th>
                        <th>Size</th>
                        <th>Qty</th>
                        <th>Lots</th>
                        <th>Unit Price</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedOrder.items &&
                        selectedOrder.items.map((item, index) => {
                          const isAccessory =
                            item.itemType === "Accessory" ||
                            item.productType !== "CPAP";
                          const isIncludedInPackage =
                            isAccessory &&
                            selectedOrder.accessoryPackageStatus &&
                            selectedOrder.accessoryPackageStatus[index];

                          return (
                            <tr
                              key={index}
                              className={isIncludedInPackage ? "bg-light" : ""}
                            >
                              <td>
                                {isAccessory ? (
                                  isIncludedInPackage ? (
                                    <Badge
                                      variant="success"
                                      title="Included in package"
                                    >
                                      ✓
                                    </Badge>
                                  ) : (
                                    <span className="text-muted">-</span>
                                  )
                                ) : (
                                  <span className="text-muted">-</span>
                                )}
                              </td>
                              <td>{item.productName}</td>
                              <td>{item.productSn}</td>
                              <td>{item.productBrand}</td>
                              <td>
                                <Badge
                                  variant={
                                    item.productType === "CPAP"
                                      ? "primary"
                                      : "info"
                                  }
                                >
                                  {item.productType}
                                </Badge>
                              </td>
                              <td>{item.size || "N/A"}</td>
                              <td>{item.quantity}</td>
                              <td>
                                {isAccessory &&
                                  !isExcelImportedSaleOrder(selectedOrder)
                                  ? formatOrderItemAllocations(item) || "-"
                                  : "-"}
                              </td>
                              <td>
                                {isIncludedInPackage ? (
                                  <span className="text-muted">
                                    <s>{formatCurrency(item.price)}</s>
                                    <small className="text-success ml-1">
                                      (Package)
                                    </small>
                                  </span>
                                ) : (
                                  formatCurrency(item.price)
                                )}
                              </td>
                              <td>
                                {isIncludedInPackage ? (
                                  <span className="text-muted">
                                    <s>
                                      {formatCurrency(
                                        item.price * item.quantity,
                                      )}
                                    </s>
                                    <small className="text-success ml-1">
                                      (Package)
                                    </small>
                                  </span>
                                ) : (
                                  formatCurrency(item.price * item.quantity)
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      {(!selectedOrder.items ||
                        selectedOrder.items.length === 0) && (
                        <tr>
                          <td colSpan="9" className="text-center text-muted">
                            No items found
                          </td>
                        </tr>
                      )}
                    </tbody>
                    <tfoot>
                      <tr>
                        <th colSpan="7" className="text-right">
                          Total Amount:
                        </th>
                        <th>{formatCurrency(selectedOrder.totalAmount)}</th>
                      </tr>
                    </tfoot>
                    {/* </table> */}
                  </Table>
                </Card.Body>
              </Card>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDetailModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit Order Modal */}
      <Modal
        show={showEditModal}
        onHide={() => {
          if (eSlipBusy) return;
          setShowEditModal(false);
          setESlipFile(null);
          setESlipPreview(null);
        }}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Edit Order - {editingOrder && editingOrder.receiptNo}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editingOrder && (
            <div>
              {/* Order Basic Information */}
              <Card className="mb-3">
                <Card.Header>
                  <h6>Order Information</h6>
                </Card.Header>
                <Card.Body>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Receipt No</label>
                        <input
                          type="text"
                          className="form-control"
                          value={editingOrder.receiptNo || ""}
                          onChange={(e) =>
                            handleEditFieldChange("receiptNo", e.target.value)
                          }
                        />
                      </div>
                      <div className="form-group">
                        <label>Receipt Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={
                            editingOrder.receiptDate
                              ? new Date(
                                  editingOrder.receiptDate.toDate
                                    ? editingOrder.receiptDate.toDate()
                                    : editingOrder.receiptDate,
                                )
                                  .toISOString()
                                  .split("T")[0]
                              : ""
                          }
                          onChange={(e) =>
                            handleEditFieldChange("receiptDate", e.target.value)
                          }
                        />
                      </div>
                      {/* <div className="form-group">
                        <label>Total Amount</label>
                        <input
                          type="number"
                          step="0.01"
                          min="0"
                          className="form-control"
                          value={editingOrder.totalAmount || ""}
                          onChange={(e) =>
                            handleEditFieldChange(
                              "totalAmount",
                              parseFloat(e.target.value) || 0
                            )
                          }
                        />
                      </div> */}
                      <div className="form-group">
                        <label>Status</label>
                        <select
                          className="form-control"
                          value={editingOrder.status || ""}
                          onChange={(e) =>
                            handleEditFieldChange("status", e.target.value)
                          }
                        >
                          <option value="เตรียมเครื่อง">เตรียมเครื่อง</option>
                          <option value="กำลังดำเนินการ">กำลังดำเนินการ</option>
                          <option value="รอเอกสาร">รอเอกสาร</option>
                          <option value="เสร็จสิ้น">เสร็จสิ้น</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Warranty Period</label>
                        <select
                          className="form-control"
                          value={
                            isSupportedWarrantyPeriod(
                              editingOrder.warrantyPeriod,
                            )
                              ? editingOrder.warrantyPeriod
                              : ""
                          }
                          onChange={(e) =>
                            handleEditFieldChange(
                              "warrantyPeriod",
                              e.target.value,
                            )
                          }
                        >
                          <option value="">Select Warranty Period</option>
                          {WARRANTY_PERIOD_OPTIONS.map((period) => (
                            <option key={period.value} value={period.value}>
                              {period.label}
                            </option>
                          ))}
                        </select>
                        {editingOrder.warrantyPeriod &&
                          !isSupportedWarrantyPeriod(
                            editingOrder.warrantyPeriod,
                          ) && (
                            <Form.Text className="text-muted">
                              Current saved period: {editingOrder.warrantyPeriod}.
                              Select a new period to replace it.
                            </Form.Text>
                          )}
                      </div>
                      <div className="form-group">
                        <label>Warranty Start Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={
                            editingOrder.warrantyStartDate
                              ? new Date(
                                  editingOrder.warrantyStartDate.toDate
                                    ? editingOrder.warrantyStartDate.toDate()
                                    : editingOrder.warrantyStartDate,
                                )
                                  .toISOString()
                                  .split("T")[0]
                              : ""
                          }
                          onChange={(e) =>
                            handleEditFieldChange(
                              "warrantyStartDate",
                              e.target.value,
                            )
                          }
                          disabled={
                            !isSupportedWarrantyPeriod(
                              editingOrder.warrantyPeriod,
                            )
                          }
                        />
                        <Form.Text className="text-muted">
                          Change this date to recalculate Warranty End Date.
                        </Form.Text>
                      </div>
                      <div className="form-group">
                        <label>Warranty End Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={
                            editingOrder.warrantyEndDate
                              ? new Date(
                                  editingOrder.warrantyEndDate.toDate
                                    ? editingOrder.warrantyEndDate.toDate()
                                    : editingOrder.warrantyEndDate,
                                )
                                  .toISOString()
                                  .split("T")[0]
                              : ""
                          }
                          readOnly
                        />
                        <Form.Text className="text-muted">
                          Auto-calculated from Warranty Start Date and Warranty
                          Period.
                        </Form.Text>
                      </div>
                      <div className="form-group">
                        <label>Sales Representative</label>
                        <select
                          className="form-control"
                          value={editingOrder.sales || ""}
                          onChange={(e) =>
                            handleEditFieldChange("sales", e.target.value)
                          }
                        >
                          <option value="">Select Sales Representative</option>
                          {salesSelect
                            .filter((sale) => sale !== "ทั้งหมด")
                            .map((sale, index) => (
                              <option key={index} value={sale}>
                                {sale}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Note</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={editingOrder.note || ""}
                      onChange={(e) =>
                        handleEditFieldChange("note", e.target.value)
                      }
                    />
                  </div>

                  {/* E-Slip Upload */}
                  <div className="form-group">
                    <div className="row">
                      <div className="col-md-6">
                        <label>
                          <strong>E-Slip Upload</strong>
                        </label>
                        <small className="d-block text-muted mb-2">
                          E-Slip uploads and deletions are saved immediately.
                        </small>
                        <div className="basic-form custom_file_input">
                          <div className="input-group mb-3">
                            <div className="input-group-prepend">
                              <span className="input-group-text">
                                {eSlipUploading ? "Uploading..." : "Upload"}
                              </span>
                            </div>
                            <div className="custom-file">
                              <input
                                type="file"
                                accept="image/*"
                                className="custom-file-input"
                                onChange={handleESlipUpload}
                                disabled={eSlipBusy}
                              />
                              <label className="custom-file-label">
                                {eSlipFile ? eSlipFile.name : "Choose image..."}
                              </label>
                            </div>
                          </div>
                        </div>
                        {eSlipPreview && (
                          <div className="mt-2 position-relative d-inline-block" style={{ maxWidth: "100%" }}>
                            <img
                              src={eSlipPreview}
                              alt="E-Slip Preview"
                              style={{
                                maxWidth: "300px",
                                maxHeight: "300px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                padding: "4px",
                              }}
                            />
                            <button
                              type="button"
                              className="close"
                              disabled={eSlipBusy}
                              onClick={handleDeleteESlip}
                              title="Delete E-Slip"
                              aria-label="Delete E-Slip"
                              style={{
                                position: "absolute",
                                top: "4px",
                                right: "4px",
                                width: "28px",
                                height: "28px",
                                padding: 0,
                                background: "transparent",
                                border: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              {eSlipDeleting ? (
                                <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
                              ) : (
                                <span aria-hidden="true" style={{ fontSize: "20px", fontWeight: 300, textShadow: "none", lineHeight: 1 }}>&times;</span>
                              )}
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* CPAP Sale Documents */}
                  {editingOrder && (
                      <div className="mt-4">
                        {/* <hr />
                      <h6 className="mb-3">CPAP Sale Documents</h6> */}
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>
                                <strong>Upload Sale Documents</strong>
                              </label>
                              <div className="basic-form custom_file_input">
                                <div className="input-group mb-3">
                                  <div className="input-group-prepend">
                                    <span className="input-group-text">
                                      Upload
                                    </span>
                                  </div>
                                  <div className="custom-file">
                                    <input
                                      type="file"
                                      multiple
                                      className="custom-file-input"
                                      onChange={onFilesChange}
                                      disabled={eSlipBusy}
                                    />
                                    <label className="custom-file-label">
                                      Choose files...
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Display existing files */}
                        {filesList && filesList.length > 0 && (
                          <div className="mt-3">
                            {/* <h6>Existing Documents</h6> */}
                            <div className="timeline">
                              {filesList.map((item, index) => (
                                <div
                                  key={item.id}
                                  className="border rounded p-3 mb-2"
                                >
                                  <div className="d-flex justify-content-between align-items-center">
                                    <div className="flex-grow-1">
                                      <div className="row">
                                        {item.cpapFile &&
                                          item.cpapFile.map(
                                            (file, fileIndex) => (
                                              <div
                                                key={fileIndex}
                                                className="mb-2 d-inline-block mr-2"
                                              >
                                                <Badge
                                                  variant="outline-light"
                                                  className="p-2 text-left"
                                                  style={{
                                                    cursor: "pointer",
                                                    maxWidth: "300px",
                                                    wordWrap: "break-word",
                                                    whiteSpace: "normal",
                                                    display: "inline-block",
                                                  }}
                                                  onClick={() =>
                                                    onViewFile(
                                                      editingOrder.items &&
                                                        editingOrder.items.find(
                                                          (i) =>
                                                            i.productType ===
                                                            "CPAP",
                                                        ) &&
                                                        editingOrder.items.find(
                                                          (i) =>
                                                            i.productType ===
                                                            "CPAP",
                                                        ).productId,
                                                      item.id,
                                                      file,
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-file mr-2"></i>
                                                  {file}
                                                </Badge>
                                                <div className="mt-1">
                                                  <Button
                                                    className="shadow btn-xs sharp mr-1"
                                                    variant="info"
                                                    onClick={() =>
                                                      onDownloadFile(
                                                        editingOrder.items &&
                                                          editingOrder.items.find(
                                                            (i) =>
                                                              i.productType ===
                                                              "CPAP",
                                                          ) &&
                                                          editingOrder.items.find(
                                                            (i) =>
                                                              i.productType ===
                                                              "CPAP",
                                                          ).productId,
                                                        item.id,
                                                        file,
                                                      )
                                                    }
                                                  >
                                                    <i className="fa fa-download"></i>
                                                  </Button>
                                                  <Button
                                                    className="shadow btn-xs sharp mr-1"
                                                    variant="danger"
                                                    disabled={eSlipBusy}
                                                    onClick={() =>
                                                      onDeleteFile({
                                                        hn: item.hn,
                                                        productId:
                                                          editingOrder.items &&
                                                          editingOrder.items.find(
                                                            (i) =>
                                                              i.productType ===
                                                              "CPAP",
                                                          ) &&
                                                          editingOrder.items.find(
                                                            (i) =>
                                                              i.productType ===
                                                              "CPAP",
                                                          ).productId,
                                                        id: item.id,
                                                      })
                                                    }
                                                  >
                                                    <i className="fa fa-trash"></i>
                                                  </Button>
                                                </div>
                                              </div>
                                            ),
                                          )}
                                      </div>
                                    </div>
                                    <div className="text-right">
                                      <small className="text-muted">
                                        <div>
                                          Created by:{" "}
                                          <strong>{item.createBy}</strong>
                                        </div>
                                        <div>
                                          {new Date(
                                            item.createAt &&
                                              item.createAt.toDate
                                              ? item.createAt.toDate()
                                              : item.createAt,
                                          ).toLocaleString()}
                                        </div>
                                      </small>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                </Card.Body>
              </Card>

              {/* Customer Information (Read-only) */}
              <Card className="mb-3">
                <Card.Header>
                  <h6>Customer Information (Read-only)</h6>
                  <Button
                    variant="outline-success"
                    size="sm"
                    onClick={handleSyncPatientData}
                    data-toggle="tooltip"
                    title="Sync Data"
                  >
                    <i className="fa fa-sync"></i> Sync Data
                  </Button>
                </Card.Header>
                <Card.Body>
                  <div className="row">
                    <div className="col-md-6">
                      <p>
                        <strong>HN:</strong> {editingOrder.hn}
                      </p>
                      <p>
                        <strong>Name:</strong> {editingOrder.firstname}{" "}
                        {editingOrder.lastname}
                      </p>
                      <p>
                        <strong>Mobile:</strong> {editingOrder.mobile || "N/A"}
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <strong>Node Ref:</strong>{" "}
                        {editingOrder.nodeRef || "N/A"}
                      </p>
                      <p>
                        <strong>Reference Customer:</strong>{" "}
                        {editingOrder.refCustomer || "N/A"}
                      </p>
                      <p>
                        <strong>Reference Hospital:</strong>{" "}
                        {editingOrder.refHospital || "N/A"}
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>

              {/* Items (Editable) */}
              <Card>
                <Card.Header className="d-flex justify-content-between align-items-center">
                  <h6 className="mb-0">
                    Order Items -{" "}
                    {editingOrder.items ? editingOrder.items.length : 0} items
                  </h6>
                  <Button
                    variant="outline-success"
                    size="sm"
                    onClick={() => setShowAddItemModal(true)}
                    data-toggle="tooltip"
                    title="Add new accessory"
                  >
                    <i className="fa fa-plus"></i> Add Accessory
                  </Button>
                </Card.Header>
                <Card.Body>
                  <Table striped bordered size="sm">
                    <thead>
                      <tr>
                        <th>Incl.</th>
                        <th>Product Name</th>
                        <th>Size</th>
                        <th>Brand</th>
                        <th>Type</th>
                        <th>Quantity</th>
                        <th>Unit Price</th>
                        <th>Total</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {editingOrder.items &&
                        editingOrder.items.map((item, index) => {
                          const isAccessory =
                            item.itemType === "Accessory" ||
                            item.productType !== "CPAP";
                          const isIncludedInPackage =
                            isAccessory && accessoryPackageStatus[index];

                          return (
                            <tr
                              key={index}
                              className={isIncludedInPackage ? "bg-light" : ""}
                            >
                              <td>
                                {isAccessory ? (
                                  <Form.Check
                                    type="checkbox"
                                    checked={isIncludedInPackage}
                                    onChange={(e) => {
                                      const newPackageStatus = {
                                        ...accessoryPackageStatus,
                                        [index]: e.target.checked,
                                      };
                                      setAccessoryPackageStatus(
                                        newPackageStatus,
                                      );

                                      // Update the item's package status
                                      handleEditItemField(
                                        index,
                                        "isIncludedInPackage",
                                        e.target.checked,
                                      );

                                      // Recalculate total amount immediately
                                      const newTotal =
                                        editingOrder.items.reduce(
                                          (sum, item, idx) => {
                                            const isAccessory =
                                              item.itemType === "Accessory" ||
                                              item.productType !== "CPAP";
                                            const isIncludedInPackage =
                                              isAccessory &&
                                              newPackageStatus[idx];

                                            if (!isIncludedInPackage) {
                                              return (
                                                sum +
                                                (item.quantity || 1) *
                                                  (item.price || 0)
                                              );
                                            }
                                            return sum;
                                          },
                                          0,
                                        );

                                      // Update the total amount in editingOrder
                                      setEditingOrder((prev) => ({
                                        ...prev,
                                        totalAmount: newTotal,
                                      }));
                                    }}
                                    title="Check if this accessory is included in the package (won't add to total price)"
                                  />
                                ) : (
                                  <span className="text-muted">-</span>
                                )}
                              </td>
                              <td>{item.productName}</td>
                              <td>{item.size || "N/A"}</td>
                              <td>{item.productBrand}</td>
                              <td>
                                <Badge
                                  variant={
                                    item.productType === "CPAP"
                                      ? "primary"
                                      : "info"
                                  }
                                >
                                  {item.productType}
                                </Badge>
                              </td>
                              <td>{item.quantity}</td>
                              <td>
                                {item.productType === "CPAP" ? (
                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    style={{ width: "100px" }}
                                    min="0"
                                    step="0.01"
                                    value={item.price || 0}
                                    onChange={(e) =>
                                      handleEditItemField(
                                        index,
                                        "price",
                                        parseFloat(e.target.value) || 0,
                                      )
                                    }
                                  />
                                ) : isIncludedInPackage ? (
                                  <span className="text-muted">
                                    <s>{formatCurrency(item.price)}</s>
                                    <small className="text-success ml-1">
                                      (Package)
                                    </small>
                                  </span>
                                ) : (
                                  formatCurrency(item.price)
                                )}
                              </td>
                              <td>
                                {isIncludedInPackage ? (
                                  <span className="text-muted">
                                    <s>
                                      {formatCurrency(
                                        (item.quantity || 1) *
                                          (item.price || 0),
                                      )}
                                    </s>
                                    <small className="text-success ml-1">
                                      (Package)
                                    </small>
                                  </span>
                                ) : (
                                  formatCurrency(
                                    (item.quantity || 1) * (item.price || 0),
                                  )
                                )}
                              </td>
                              <td>
                                <Link
                                  to="#"
                                  className="btn btn-danger shadow btn-xs sharp"
                                  onClick={() => handleRemoveItem(index)}
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Remove item"
                                >
                                  <i className="fa fa-trash"></i>
                                </Link>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </Table>

                  {editingOrder.items && editingOrder.items.length === 0 && (
                    <div className="text-center text-muted py-3">
                      <p>No items in this order</p>
                    </div>
                  )}

                  <div className="mt-3">
                    <div className="row">
                      <div className="col-md-8"></div>
                      <div className="col-md-4">
                        <div className="border p-2 d-flex justify-content-between align-items-center">
                          <strong>Total Amount:</strong>
                          <div className="d-flex align-items-center">
                            <span className="mr-2">฿</span>
                            <input
                              type="number"
                              step="0.01"
                              min="0"
                              className="form-control form-control-sm"
                              style={{
                                width: "100px",
                                textAlign: "right",
                                fontWeight: "bold",
                              }}
                              value={editingOrder.totalAmount || 0}
                              onChange={(e) =>
                                handleEditFieldChange(
                                  "totalAmount",
                                  parseFloat(e.target.value) || 0,
                                )
                              }
                            />
                          </div>
                        </div>
                        <div className="text-right mt-2">
                          <small className="text-muted">
                            Auto-calculated:{" "}
                            {formatCurrency(calculateOrderTotal())}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={handleSaveOrder}
            disabled={eSlipBusy}
          >
            Save Changes
          </Button>
          <Button
            variant="secondary"
            disabled={eSlipBusy}
            onClick={() => {
              setShowEditModal(false);
              setESlipFile(null);
              setESlipPreview(null);
            }}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Add Item Modal */}
      <Modal
        show={showAddItemModal}
        onHide={() => setShowAddItemModal(false)}
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Accessory</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Select Accessory</Form.Label>
              <Form.Control
                as="select"
                value={selectedAccessory ? selectedAccessory.id : ""}
                onChange={(e) => {
                  const accessory = availableAccessories.find(
                    (acc) => acc.id === e.target.value,
                  );
                  setSelectedAccessory(accessory);
                  setNewItemPrice(accessory ? accessory.unitPrice || 0 : 0);
                }}
                onFocus={() => {
                  if (availableAccessories.length === 0) {
                    loadAvailableAccessories();
                  }
                }}
              >
                <option value="">Select an accessory...</option>
                {availableAccessories.map((accessory) => (
                  <option key={accessory.id} value={accessory.id}>
                    {accessory.itemName}
                    {accessory.size ? ` (Size: ${accessory.size})` : ""} -{" "}
                    {accessory.brand} (Stock: {accessory.stockQuantity})
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            {selectedAccessory && (
              <>
                <div className="mb-3">
                  <strong>Item Details:</strong>
                  <ul>
                    <li>Brand: {selectedAccessory.brand}</li>
                    <li>Category: {selectedAccessory.category}</li>
                    <li>Code: {selectedAccessory.itemCode}</li>
                    <li>Available Stock: {selectedAccessory.stockQuantity}</li>
                  </ul>
                </div>

                <Form.Group className="mb-3">
                  <Form.Label>Quantity</Form.Label>
                  <Form.Control
                    type="number"
                    min="1"
                    max={selectedAccessory.stockQuantity}
                    value={newItemQuantity}
                    onChange={(e) =>
                      setNewItemQuantity(parseInt(e.target.value) || 1)
                    }
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Unit Price</Form.Label>
                  <Form.Control
                    type="number"
                    min="0"
                    step="0.01"
                    value={newItemPrice}
                    onChange={(e) =>
                      setNewItemPrice(parseFloat(e.target.value) || 0)
                    }
                  />
                </Form.Group>

                <div className="mb-3">
                  <strong>
                    Total: {formatCurrency(newItemQuantity * newItemPrice)}
                  </strong>
                </div>
              </>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={handleAddNewItem}
            disabled={!selectedAccessory}
          >
            Add to Order
          </Button>
          <Button
            variant="secondary"
            onClick={() => setShowAddItemModal(false)}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Email Modal */}
      {!emailLoading && (
        <Modal
          className="fade bd-example-modal-lg"
          show={mailModal}
          onHide={toggle}
          size="lg"
        >
          <Modal.Header>
            <Modal.Title>Send Email</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group row m-1">
              <label className="col-lg-4 col-form-label">
                Accountant Email
              </label>
              <div className="col-lg-6">
                <select
                  className="form-control"
                  onChange={(e) => setSelectEmail(e.target.value)}
                  value={selectEmail}
                >
                  {emailList.map((opt, index) => (
                    <option key={index} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
          <div className="d-flex justify-content-between mb-3 mx-3">
            <Button className="sm" onClick={() => handleSendSubmit(true)}>
              Send All
            </Button>
            <div>
              <Button className="sm" onClick={() => handleSendSubmit(false)}>
                Send
              </Button>
              <Button className="sm ml-2" variant="light" onClick={toggle}>
                Cancel
              </Button>
            </div>
          </div>
        </Modal>
      )}

      {/* File Viewer Modal */}
      <Modal
        show={showFileModal}
        onHide={() => setShowFileModal(false)}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>File Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body className="m-0 p-0">
          <div
            className="card-body mx-0 p-0 col-lg-12"
            style={{ height: "85vh" }}
          >
            {fileType === "image" ? (
              // Render image with proper fit
              <img
                src={fileUrl}
                alt="File Preview"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            ) : (
              // Render PDF in iframe
              <iframe
                className="col-lg-12 m-0 p-0"
                src={fileUrl + "#toolbar=0"}
                width="100%"
                height="100%"
                title="File Preview"
              ></iframe>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};

// Redux connection
const mapStateToProps = (state, props) => ({
  filesList: selectFiles(state.productFiles),
});

const mapDispatchToProps = (dispatch) => ({
  startSetFiles: (id, patient) => dispatch(startSetFiles(id, "cpapfile", patient)),
  setFiles: (files) => dispatch(setFiles(files)),
  startAddFile: (data, files) => dispatch(startAddFile(data, files)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SaleOrderList);
